/**
 * Replicates getVariantConfig isMTO logic from product-info.js for bundle variants.
 * Reads from window.bundle_data (populated in bundle-product.liquid) instead of
 * window.variantMetafields (which is only populated on main-product pages).
 *
 * MTO = ALL four conditions must be true:
 *   1. is_mto metafield is explicitly true
 *   2. inventory_quantity <= 0
 *   3. available === true  (can still be purchased)
 *   4. inventory_policy === 'continue' (continue selling when OOS)
 *
 * @param {string|number} variantId
 * @returns {boolean}
 */
function isBundleVariantMTO(variantId) {
  if (!variantId || !window.bundle_data) return false;

  for (const category of Object.values(window.bundle_data)) {
    if (!Array.isArray(category)) continue;
    for (const bundleProduct of category) {
      if (!Array.isArray(bundleProduct.variants)) continue;
      const variant = bundleProduct.variants.find(v => String(v.id) === String(variantId));
      if (variant) {
        return (
          variant.is_mto === true &&
          variant.inventory_quantity <= 0 &&
          variant.available === true &&
          variant.inventory_policy === 'continue'
        );
      }
    }
  }
  return false;
}

// handleize form of label
const handleize = str => str
  .toLowerCase()
  .replace(/[^\w\s-]/g, '') // remove special characters
  .replace(/\s+/g, '-')     // replace spaces with hyphens
  .replace(/-+/g, '-');

function getDiscountText(comparePrice, price, extraDiscountPer) {
  if (!comparePrice || !price) return "";

  const discount = Math.floor(((comparePrice - price) / comparePrice) * 100);

  if (discount > 0) {
    return `(${discount}% off)`;
  }
  return "";
}
function sliders() {
  window.mainSlider?.destroy(true, true);
  window.thumbnailSlider?.destroy(true, true);

  const paginationEl = document.querySelector(".pdp-main-slider-wrap .swiper-pagination");
  // console.log("paginationEl",paginationEl);
  if (paginationEl) {
    paginationEl.innerHTML = ""; // Clear old pagination bullets
    // paginationEl.remove();
  }

  //   //create new dots pagination
  // const newPagination = document.createElement('div');
  // newPagination.className = 'swiper-pagination flexbox justify-center large-up-hide';
  // document.querySelector('.pdp-main-slider-wrap').appendChild(newPagination);
  // Remove old pagination
  const oldPaginationEl = document.querySelector(".pdp-main-slider-wrap .swiper-pagination");
  if (oldPaginationEl) {
    oldPaginationEl.remove();
  }

  // // Create and append new pagination
  const newPagination = document.createElement('div');
  newPagination.className = 'swiper-pagination flexbox justify-center large-up-hide';
  document.querySelector('.pdp-main-slider-wrap').appendChild(newPagination);
  
  // Wait until DOM updates are fully applied (especially slide visibility)
  requestAnimationFrame(() => {
    window.mainSlider = new Swiper(".main-slider", {
      slidesPerView: 1,
      autoHeight: true,
      watchOverflow: true,
      simulateTouch: true,
      pagination: {
        el: ".pdp-main-slider-wrap .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".pdp-main-slider-wrap .swiper-button-next",
        prevEl: ".pdp-main-slider-wrap .swiper-button-prev",
      }
    });
    
    window.thumbnailSlider = new Swiper(".thumbnail-slider", {
      slidesPerView: 3,
      spaceBetween: 10,
      watchOverflow: true,
      breakpoints: {
        575: { slidesPerView: 4 },
        1081: { slidesPerView: 5 }
      }
    });

    // window.mainSlider.slideTo(0);
    
    // window.thumbnailSlider.on("click", (swiper) => {
    //   console.log('click')
    //   const idx = swiper.clickedIndex;
    //   window.mainSlider.slideTo(idx);
    //   updateThumbnailActiveClass(window.thumbnailSlider, idx);
    // });
    // window.mainSlider.on("slideChangeTransitionEnd", () => {
    //   const idx = window.mainSlider.activeIndex;
    //   // console.log(idx)
    //   window.thumbnailSlider.slideTo(idx);
    //   updateThumbnailActiveClass(window.thumbnailSlider, idx);
    // });

    // function updateThumbnailActiveClass(swiper, idx) {
    //   swiper.slides.forEach((slide, i) => {
    //     slide.classList.toggle("swiper-slide-active", i === idx);
    //     slide.classList.toggle('slide-active', i === idx);
    //   });
    // }
    window.mainSlider.slideTo(0);

    window.thumbnailSlider.on("click", (swiper) => {
      const idx = swiper.clickedIndex;
      window.mainSlider.slideTo(idx);
      updateThumbnailActiveClass(window.thumbnailSlider, idx);
    });
    
    window.mainSlider.on("slideChangeTransitionEnd", () => {
      const idx = window.mainSlider.activeIndex;
      updateThumbnailActiveClass(window.thumbnailSlider, idx);
    });
    
    function updateThumbnailActiveClass(swiper, idx) {
      swiper.slides.forEach((slide, i) => {
        const isActive = i === idx;
        slide.classList.toggle("swiper-slide-active", isActive);
        slide.classList.toggle("slide-active", isActive);
      });
    
      // Adjust visible thumbnail position (center active thumb)
      const offsetIndex = Math.max(idx - 1, 0);
      swiper.slideTo(offsetIndex);
    }
    updateThumbnailActiveClass(window.thumbnailSlider, 0);
    
   //Ak custom code    
    let dragStartX = 0;
      
    window.mainSlider.on('touchStart', (swiper, event) => {
      // console.log('touchStart')
      dragStartX = event.touches?.[0]?.clientX || event.clientX;
    });
      
      // window.mainSlider.on('touchEnd', (swiper, event) => {
      //   console.log('touchEnd')
      //   const dragEndX = event.changedTouches?.[0]?.clientX || event.clientX;
      //   const deltaX = dragEndX - dragStartX;
      //   const threshold = 30; // Minimum drag distance
      
      //   if (Math.abs(deltaX) > threshold) {
      //     if (deltaX > 0) {
      //       // Swiped right
      //       if (!swiper.isBeginning) {
      //         // console.log("Swiped right, go to previous");
      //         swiper.slidePrev();
      //       } else {
      //         // console.log("At first slide, can't go left");
      //       }
      //     } else {
      //       // Swiped left
      //       if (!swiper.isEnd) {
      //         // console.log("Swiped left , go to next");
      //         swiper.slideNext();
      //       } else {
      //         // console.log("At last slide, can't go right");
      //       }
      //     }
      //   }
      // });
      
      //End Ak custom code
    
    
       
    // Also update pagination after Swiper is initialized
    window.mainSlider.pagination?.render();
    window.mainSlider.pagination?.update();
  });
}

function renderBundle(categoryName) {
  const container = document.querySelector(".customBundle_block .bundle_info_wrapper");
  container.innerHTML = "";

  const data = window.bundle_data?.[categoryName] || [];
  console.log("data>>>",data);

  //Ak custom code
  // console.log('categoryName',categoryName);
  let bed_show_pincode = false;
  if(categoryName == 'bed'){
    const bundletab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="'+categoryName+'"]');
    if(!bundletab.classList.contains('added') && !bundletab.classList.contains('pin_valid')){
       bed_show_pincode = true;
    }

  }
  //End Ak custom code
  

  const extraDiscount = document.querySelector(".customBundle_block").getAttribute("data-bundle-discount");
  
  // Create and append bundle wrapper
  const bundleWrapper = document.createElement("div");
  bundleWrapper.className = "bundle-content-wrapper";
  
  const titlesContainer = document.createElement("div");
  titlesContainer.className = "product-titles-container";

  const titleLabel = document.createElement("label");
  titleLabel.className = "title_label";
  titleLabel.textContent = 'SELECT A PRODUCT';
  titlesContainer.appendChild(titleLabel);
  bundleWrapper.appendChild(titlesContainer);

  const variantContainer = document.createElement("div");
  variantContainer.className = "variant-container";
  bundleWrapper.appendChild(variantContainer);

  const bundleActionContainer = document.createElement("div");
  bundleActionContainer.className = "bundle-action-container";
  
  
  bundleActionContainer.innerHTML = `
    <div class="action-info-wrapper">
      <div class="variant-info"></div>
    </div>
    <div class="mto-message-container" style="margin-top: 12px; margin-bottom: 12px;">
      <div
        class="mto-message mto-message--standard hidden"
        data-mto-type="standard"
        style="padding: 12px 16px; background: #fff3cd; border-left: 4px solid #ffc107; border-radius: 4px; font-size: 14px; line-height: 1.5;"
      >
        <span class="mto-message-text" style="color: #856404;">Made to order, just for you. Dispatches from our factory in 3–5 days.</span>
        <a href="javascript:void(0);" class="mto-check-timeline" style="margin-left: 1px; font-weight: 500; color: #856404; text-decoration: underline; cursor: pointer;">Check estimated timeline</a>
      </div>
      <div
        class="mto-message mto-message--custom hidden"
        data-mto-type="custom"
        style="padding: 12px 16px; background: #fff3cd; border-left: 4px solid #ffc107; border-radius: 4px; font-size: 14px; line-height: 1.5;"
      >
        <span class="mto-message-text" style="color: #856404;">Custom-made, just for you. Dispatches from our factory in 3–5 days.</span>
        <a href="javascript:void(0);" class="mto-check-timeline" style="margin-left: 1px; font-weight: 500; color: #856404; text-decoration: underline; cursor: pointer;">Check estimated timeline</a>
      </div>
    </div>
  `;

  
  // MTO message helpers (scoped to this renderBundle call)
  const showBundleMTOMessage = (type) => {
    const standardEl = bundleActionContainer.querySelector('.mto-message--standard');
    const customEl = bundleActionContainer.querySelector('.mto-message--custom');
    standardEl?.classList.toggle('hidden', type !== 'standard');
    customEl?.classList.toggle('hidden', type !== 'custom');
  };
  const hideBundleMTOMessages = () => {
    bundleActionContainer.querySelector('.mto-message--standard')?.classList.add('hidden');
    bundleActionContainer.querySelector('.mto-message--custom')?.classList.add('hidden');
  };

  // Insert the minimum quantity notice after the action-info-wrapper if needed
  // const minQty = window.bundle_data?.[categoryName]?.minQuantity || 0;
  // if (minQty >= 1) {
  //   const minNotice = document.createElement("p");
  //   minNotice.className = "min-qty-note";
  //   minNotice.textContent = `*Add minimum ${minQty} product${minQty > 1 ? "s" : ""} from this category`;
  
  //   const actionInfoWrapper = bundleActionContainer.querySelector(".action-info-wrapper");
  //   if (actionInfoWrapper) {
  //     actionInfoWrapper.after(minNotice); // Insert directly after .action-info-wrapper
  //   } else {
  //     bundleActionContainer.appendChild(minNotice); // Fallback
  //   }
  // }
  
  // Append the fully constructed container
  container.appendChild(bundleActionContainer);
  bundleWrapper.appendChild(bundleActionContainer);

  //Ak custom code
  // if(categoryName == 'bed'){
      const deliveryInput = document.createElement("div");
      deliveryInput.className = "delivery_input";
      deliveryInput.innerHTML = `
      <div class="delivery_input_main">
        <div class="delivery_input_inner">
          <center><span id="delpicMsg"></span></center>
          <h6 class="delivery_pincode_title">CHECK IF YOUR LOCATION IS ELIGIBLE FOR DELIVERY AND INSTALLATION</h6>
          <div class="pincode-wrapper">
            <input type="text" id="pincode" class="input-text pincode" data-type="product" data-pincodestatus="valid" data-sku="" data-producttype="" data-outofstock="" data-custom="false" maxlength="6" placeholder="enter pincode" data-sharkid="__2">
            <a href="javascript:;" class="btn btn-orange pin-check" onclick="checkPincodePP()">Check</a>
          </div>
        
          <div id="checkPincodeDesc" style="display:none; margin-bottom: 15px;"></div>
        </div>
      </div>
      `;    
      bundleWrapper.appendChild(deliveryInput);
  // }
  // if(bed_show_pincode){
  // // console.log('categoryName',categoryName);
  //   variantContainer.classList.add('hidden');
  //   // bundleActionContainer.classList.add('hidden');
  // }
  
  //End Ak custom code

  container.appendChild(bundleWrapper);


//Ak custom code

  const pincodeInput = document.querySelector(".pincode-wrapper input#pincode");

  if(pincodeInput){
    pincodeInput.addEventListener("keydown", function (e) {
      pincodeInput.setAttribute("data-pincodestatus", "invalid");
    
      // Clear the msg
      const delpicMsg = document.getElementById("delpicMsg");
      if (delpicMsg) {
        delpicMsg.innerHTML = "";
      }  
      // call function when click enter key
      if (e.keyCode === 13) {
        checkPincodePP();
      }
    });

    ["keydown", "input", "paste"].forEach(eventType => {
      pincodeInput.addEventListener(eventType, function (e) {
        // console.log('hihih')
        return isNumberKey(e); // use the passed event object, not `event`
      });
    });


  }
  
  // if(categoryName == 'bed'){
  //   const bundletab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="'+categoryName+'"]');
  //   if(bundletab){
      
  //     if(bundletab.classList.contains('pin_valid')){
  //       const delivery_input = document.querySelector('.bundle_info_wrapper .delivery_input');
  //       if(delivery_input){
  //         delivery_input.classList.add('hidden');
  //       }
        
        
  //       const get_pincode = bundletab.getAttribute('data-pincode');
  //       const pincodeEligibleHTML = `
  //         <div class="custombundle-check-pincode-setFor">
  //           <span>Pincode is eligible for delivery:</span>
  //           <span id="custombundle-setPinCode" class="px-1">${get_pincode}</span>
  //           <span id="custombundle-changePinCode" class="fa fa-edit d-inline-block"></span>
  //         </div>
  //         `;
  
  //         // Select the .product-titles-container element
  //         const productTitlesContainer = document.querySelector('.bundle-content-wrapper .product-titles-container');
          
  //         if (productTitlesContainer) {
  //           productTitlesContainer.insertAdjacentHTML('afterend', pincodeEligibleHTML);
  //         }
  //     }
  //   }
  // }
  //End Ak custom code
  
  // const maxQuantity =  bundle_data[categoryName].maxQuantity;
  // const quantityInput = bundleActionContainer.querySelector('.quantity__input');
  // quantityInput.setAttribute('max',maxQuantity);
  
  data.forEach((product, pIndex) => {
    // console.log("product",product);
    if(product.variants.length <= 0) return;
   
    const titleBtn = document.createElement("button");
    titleBtn.className = "product-title-btn";
    const txt = document.createElement("textarea");
    txt.innerHTML = product.title;
    // console.log("txt", txt)
    titleBtn.textContent = txt.value;
    titleBtn.dataset.originalTitle = txt.value;

    titlesContainer.appendChild(titleBtn);
    if (pIndex === 0) {
      titleBtn.classList.add("active");
    }
    titleBtn.dataset.category = categoryName; // `category` must be in scope
    titleBtn.dataset.handle = product.handle;
    
    const productDiv = document.createElement("div");
    productDiv.className = "bundle-product";
    productDiv.setAttribute("data-title",product.title);
    productDiv.dataset.productIndex = pIndex;
    productDiv.style.display = pIndex === 0 ? "block" : "none";
    // if (pIndex === 0) {
    //   productDiv.classList.add("active");
    // }
    variantContainer.appendChild(productDiv);

    //Ak custom code
    const delivery_input = document.querySelector('.delivery_input');
    if(delivery_input){
      const input_pin = delivery_input.querySelector('input#pincode');
      if(input_pin){
        input_pin.setAttribute('data-producttype',product.pro_type);
      }
    }
    //End Ak custom code

    // if(product.description){
    
    //   const descriptionLabel = document.createElement("label");
    //   descriptionLabel.classList.add("bundle_dec_label");
    //   descriptionLabel.textContent = "Product Description";
    //   productDiv.appendChild(descriptionLabel);
      
    //   // Create and append description content
    //   const descriptionContent = document.createElement("div");
    //   descriptionContent.className = "product-description-content";
     
    //   // Assuming bundle.description contains your HTML or plain text
    //   descriptionContent.innerHTML = product.description || "No description available";
    //   productDiv.appendChild(descriptionContent);
    // }
const colorGroup = document.querySelector(".option-group.color");
const variantInfo = product.variants;
    let handleBundleCustomChange = null;
    product.options.forEach((optName, optIndex) => {
    // product.options.forEach((option, optIndex) => {
      // const optName = option.name;
      // console.log("optName",optName);
      
      const groupDiv = document.createElement("div");
      groupDiv.className = "option-group "+ handleize(optName) +"";
      const handleizedOptName = handleize(optName);
      groupDiv.setAttribute("data-option-name", handleizedOptName);
      groupDiv.dataset.option = optIndex + 1;

      const label = document.createElement("p");
      label.innerHTML = `<strong>${optName}</strong>`;
      groupDiv.appendChild(label);


      const values = [...new Set(product.variants.map(v => v[`option${optIndex + 1}`]).filter(Boolean))];
console.log("values======", values)
      const mattress = selectedBundleProducts.find(item => item.category === "mattress");
      const pillow = selectedBundleProducts.find(item => item.category === "pillow");

      const matchedCategoryData = selectedBundleProducts.find(item => item.category === categoryName);

      const isDimensionOpt = optName === 'Dimension' || optName === 'DIMENSION' || optName === 'dimension';
      const pillsWrap = isDimensionOpt ? null : (function() {
        const wrap = document.createElement('div');
        wrap.className = 'variant-pill-list-wrap flexbox';
        return wrap;
      })();

      values.forEach((value, vIndex) => {
        const inputId = `opt${optIndex}-${pIndex}-${vIndex}`;
        const input = document.createElement("input");
        input.type = "radio";
        input.name = `option${optIndex}-${pIndex}`;
        input.id = inputId;
        input.value = value;

        // Default check state
        let shouldCheck = false;

        // Use matched value if mattress or pillow is in selectedBundleProducts
        if (matchedCategoryData) {
          // console.log("matchedCategoryData",matchedCategoryData);
          const selectedOptionKey = `option${optIndex + 1}`;
          const matchedValue = matchedCategoryData.selectedOptions?.[selectedOptionKey];
          // console.log("matchedValue",matchedValue);
          if (matchedValue && matchedValue === value) {
            shouldCheck = true;
          }
        } else {
          // Fallback logic for first option if mattress or pillow isn't selected yet
          if (!mattress || !pillow) {
            shouldCheck = vIndex === 0;
          }
        }

        if (shouldCheck) input.checked = true;

        const label = document.createElement("label");
        label.htmlFor = inputId;
        label.textContent = value;

        function decodeHtml(str) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}

        // Swatch rendering (image or color)
        const optNameLower = optName.toLowerCase();
        if (optNameLower.includes("color")) {
          const optionImageData = product.optionImages.find(img => img.name.toLowerCase() === optNameLower);
          if (optionImageData) {
            const matchedValue = optionImageData.values.find(v => decodeHtml(v.value) === value);
            // console.log("matchedValue-------", matchedValue)
            if (matchedValue) {
              if (matchedValue.swatch_type === "image") {
                label.style.backgroundImage = `url(${matchedValue.swatch_value})`;
                label.textContent = "";
              } else if (matchedValue.swatch_type === "color") {
                label.style.backgroundColor = matchedValue.swatch_value;
                label.textContent = "";
              }
            }
          }
        }
        else{
          console.log("no colorrrrrrrrrrrrrrr")
        }

        if (pillsWrap) {
          const variantPill = document.createElement('div');
          variantPill.className = 'variant-pill';
          variantPill.appendChild(input);
          variantPill.appendChild(label);
          pillsWrap.appendChild(variantPill);
        } else {
          groupDiv.appendChild(input);
          groupDiv.appendChild(label);
        }
      });

      // For mattress category option: add .custom-size pill inside .variant-pill-list-wrap
      if (pillsWrap) {
        const _isMattressTopper = product.handle.includes('mattress-topper') && !product.handle.includes('microfiber-mattress-topper');
        if (
          categoryName === 'mattress' &&
          handleize(optName) === 'category' &&
          !/(cover|protector)/.test(product.handle) &&
          !(product.handle.includes('topper') && !_isMattressTopper) &&
          product.handle !== 'tri-fold-mattress' &&
          product.handle !== 'cloud-spring-mattress'
        ) {
          const customSizePill = document.createElement('div');
          customSizePill.className = 'custom-size';
          customSizePill.innerHTML = '<label>Custom Size</label>';
          pillsWrap.appendChild(customSizePill);
        }
        groupDiv.appendChild(pillsWrap);
      }
      // ✅ Color/Colorstyle title → "Color: {selected}"
const isColorGroup =
  handleizedOptName === "color" ||
  handleizedOptName === "colorstyle" ||
  optName.toLowerCase().includes("color");

if (isColorGroup) {
  const titleP = groupDiv.querySelector("p"); // this is your <p> created earlier
  const baseTitle = optName; // "Color" or "Color/Style"

  const setTitleFromSelection = () => {
    const checked =
      groupDiv.querySelector('input[type="radio"]:checked') ||
      groupDiv.querySelector('input[type="radio"]');

    const selectedColor = checked?.value ? checked.value.trim() : "";
    titleP.innerHTML = `<strong>${baseTitle}: ${selectedColor}</strong>`;
  };

  // set default text (uses the default checked one; otherwise first)
  setTitleFromSelection();

  // update on click/change (covers swatch label click too, because it checks the radio)
  groupDiv.addEventListener("change", (e) => {
    if (e.target && e.target.matches('input[type="radio"]')) {
      setTitleFromSelection();
    }
  });
}

      // console.log("optName",optName);
      // If get and dimension option custom functionality
      if (optName == 'Dimension' || optName == 'DIMENSION' || optName == 'dimension') {
        const lastValuesSet = new Set();
          values.forEach(value=>{
          // option.values.forEach(valueObj => {
          // const value = valueObj.value;
            const xCount = (value.match(/x/g) || []).length;
            if (xCount === 2) {
              const parts = value.split('x');
              const last = parts[parts.length - 1].trim();
              lastValuesSet.add(last);
            }
          });
          
        const uniqueLastValues = Array.from(lastValuesSet);
        if (uniqueLastValues.length > 1) {
            // Create the height option wrapper (to go inside its own .option-group)
            const heightOptionWrapper = document.createElement("div");
            heightOptionWrapper.className = "height_option_wrapper";
          
            const title = document.createElement("p");
            title.textContent = "Heights";
            heightOptionWrapper.appendChild(title);
          
            // const divContainer = document.createElement("div");
            // divContainer.className = "height-values-container flexbox";
          
            // uniqueLastValues.forEach(val => {
            //   const valueDiv = document.createElement("div");
            //   valueDiv.className = "height-value";
            //   valueDiv.setAttribute("data-value",val);
            //   valueDiv.textContent = val + ' inch';
            //   divContainer.appendChild(valueDiv);
            // });
          
            // heightOptionWrapper.appendChild(divContainer);

            const divContainer = document.createElement("div");
divContainer.className = "height-values-container flexbox";

// sort ascending
uniqueLastValues.sort((a, b) => Number(a) - Number(b));

uniqueLastValues.forEach(val => {
  const valueDiv = document.createElement("div");
  valueDiv.className = "height-value";
  valueDiv.setAttribute("data-value", val);
  valueDiv.textContent = val + " inch";
  divContainer.appendChild(valueDiv);
});

heightOptionWrapper.appendChild(divContainer);
           
          
            const heightOptionGroup = document.createElement("div");
            heightOptionGroup.className = "option-group height-option-group";
            heightOptionGroup.setAttribute("data-option-name","height");
            heightOptionGroup.appendChild(heightOptionWrapper);
            if (product.handle.includes('mattress-topper')) {
              heightOptionGroup.style.display = 'none';
            }
            productDiv.appendChild(heightOptionGroup);

            var heightOptions = productDiv.querySelectorAll(".height-values-container .height-value");
            
            if(heightOptions.length){
              heightOptions.forEach((heightOption)=>{
                heightOption.addEventListener('click',function(){
                  heightOptions.forEach((elem)=>{
                    elem.classList.remove("active");
                  });
                  heightOption.classList.add("active");
                  var heightValue = this.getAttribute("data-value");

                  // If custom size is active for this product, re-run mapping
                  if (typeof handleBundleCustomChange === 'function' && productDiv.querySelector('.custom-size.active')) {
                    setTimeout(handleBundleCustomChange, 0);
                  }

                  const dimensionItems = productDiv.querySelectorAll(".dimension-list li:not(.hidden)");
                  dimensionItems.forEach((li) => {
                    const value = li.getAttribute("data-value") || li.textContent;
                    const xCount = (value.match(/x/g) || []).length;
            
                    if (xCount === 2) {
                      const parts = value.split('x');
                      const last = parts[parts.length - 1].trim();
            
                      if (last === heightValue) {
                        li.classList.remove("not-available");
                      } else {
                        // console.log("not-available added 1");
                        li.classList.add("not-available");
                      }
                    } else {
                       // console.log("not-available added 2");
                      li.classList.add("not-available");
                    }
                  });
                });
              });
              setTimeout(()=>{
                 const alreadySelected =  selectedBundleProducts.find(
                    item => item.category.toLowerCase() === categoryName.toLowerCase()
                  );
                  if(!alreadySelected){
                    if (product.handle === 'founders-mattress') {
                      const foundersDefault = productDiv.querySelector('.height-value[data-value="9"]');
                      (foundersDefault || heightOptions[0])?.click();
                    } else if (product.handle === 'mattress-cover') {
                      // Inline height filter (applyMattressCoverHeightFilter is out of scope here)
                      const checkedMT = productDiv.querySelector('.option-group[data-option-name="mattress-type"] input[type="radio"]:checked');
                      const mtLabel = (checkedMT?.value || '').toLowerCase().trim();
                      const h6init = productDiv.querySelector('.height-value[data-value="6"]');
                      const h10init = productDiv.querySelector('.height-value[data-value="10"]');
                      h6init?.classList.remove('hidden');
                      h10init?.classList.remove('hidden');
                      if (mtLabel.includes('ultima')) {
                        h6init?.classList.add('hidden');
                      } else if (mtLabel.includes('hybrid')) {
                        h10init?.classList.add('hidden');
                      }
                      const defaultHeight = mtLabel.includes('ultima') ? '8' : '6';
                      const preferredHeight = productDiv.querySelector(`.height-value[data-value="${defaultHeight}"]:not(.hidden)`);
                      (preferredHeight || productDiv.querySelector('.height-values-container .height-value:not(.hidden)'))?.click();
                    } else {
                      if (heightOptions[0]) heightOptions[0].click();
                    }
                  }
              });
            }
          }
          
        const customGroupDiv = document.createElement("div");
        customGroupDiv.className = "option-group custom-dimension-option-group";
          
        const label = document.createElement("p");
        label.innerHTML = `<strong>Dimension</strong>`;
        customGroupDiv.appendChild(label);
        
        // Create converter_wrapper div
        // const converterWrapper = document.createElement("div");
        // converterWrapper.className = "converter_wrapper flexbox";
        // converterWrapper.innerHTML = `
        //   <span class="convert convert_inch active"> inch </span>
        //   |<span class="convert convert_cm"> cm </span>|
        //   <span class="convert convert_feet"> feet </span>
        // `;
        // customGroupDiv.appendChild(converterWrapper); // Append it right after the label
        
        const wrapper = document.createElement("div");
        wrapper.className = "dimension-wrapper";

        const errorWrapper = document.createElement("span");
        errorWrapper.className = "variation-error hidden";
        errorWrapper.textContent = "Please select a size before adding to cart!";

        const labelWrapper = document.createElement("span");
        labelWrapper.className = "custom-dropdown";
        
        const span = document.createElement("span");
        span.className = "dimension-label";
        span.textContent = "Select a size";
        labelWrapper.appendChild(span);

        const arrowSpan = document.createElement("span");
        arrowSpan.className = "dropdown-arrow flexbox align-center justify-center";
        arrowSpan.innerHTML = `<svg class="icon icon--faq_arrow" width="24" height="13" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.7184 0.379473C22.2516 -0.135427 23.1012 -0.123727 23.6188 0.404673C24.1364 0.935072 24.1247 1.78027 23.5915 2.29517L12.8923 12.6178L11.9548 11.66L12.8923 12.6217C12.3571 13.1366 11.5055 13.1249 10.986 12.5926C10.9704 12.577 10.9567 12.5615 10.943 12.5459L0.407851 2.29517C-0.125352 1.78027 -0.137072 0.935074 0.380506 0.404674C0.898089 -0.125726 1.74965 -0.135426 2.2809 0.379474L11.9587 9.79478L21.7184 0.379473Z" fill="currentColor"/>
        </svg>`;
        labelWrapper.appendChild(arrowSpan);

        wrapper.appendChild(labelWrapper);
        
        const ul = document.createElement("ul");
        ul.className = "dimension-list";
console.log("variantInfo", variantInfo, "for values", values);

const skuByDimension = new Map(
  variantInfo.map(v => {
    const dimension = (v.title || "").split("/")[1]?.trim(); // "72 x 36 x 4"
    return [dimension, { sku: v.sku, price: v.price, compare_at_price: v.compare_at_price }];
  })
);

        values.forEach(value => {
          // option.values.forEach(valueObj => {
          // const value = valueObj.value;
          const li = document.createElement("li");
          li.className = "dimension-value";
          li.setAttribute("data-value", value);
          const variantData = skuByDimension.get(value);
if (variantData) {
  li.setAttribute("data-sku", variantData.sku);
  li.setAttribute("data-price", variantData.price);
  li.setAttribute("data-compare_at_price", variantData.compare_at_price);
}
          li.textContent = value + ' inches';
          ul.appendChild(li);
        });
 
        wrapper.appendChild(ul);

        const list = document.querySelector("ul.dimension-list");
const firstLi = list?.querySelector("li.dimension-value[data-value]"); 
// console.log("firstLi found!!!!!!", firstLi)
const dimensionLabel = document.querySelector(".dimension-label"); 
if (firstLi && dimensionLabel) {
  const selectedValue = firstLi.getAttribute("data-value");
  console.log("firstLi in 1", firstLi)
  firstLi.setAttribute("selected", "selected");
  dimensionLabel.textContent = selectedValue + " inches";
  dimensionLabel.setAttribute("data-selected", selectedValue);
  // const sku = skuByDimension.get(selectedValue);
  // if (sku) dimensionLabel.setAttribute("data-sku", sku);
  productDiv
    .querySelector(`.option-group.dimension input[value="${selectedValue}"]`)
    ?.click();
//   const radio = productDiv.querySelector(`.option-group.dimension input[value="${selectedValue}"]`);
// if (radio) {
//   radio.checked = true;
//   radio.dispatchEvent(new Event("change", { bubbles: true }));
// }
}

        customGroupDiv.appendChild(wrapper);
        customGroupDiv.appendChild(errorWrapper);
        productDiv.appendChild(customGroupDiv);

        // Custom Size for mattress: add .custom-size-wrapper with L and W inputs (height from .height-value.active)
        if (categoryName === 'mattress') {
          const dimOptIdx = product.options.findIndex(opt => opt.toLowerCase() === 'dimension');
          if (dimOptIdx !== -1) {
            const dimKey = `option${dimOptIdx + 1}`;

            // Per-handle min/max matching product-variant-picker.liquid
            let minL, maxL, minW, maxW;
            const productHandle = product.handle;
            if (productHandle === 'baby-mattress') {
              minL = 30; maxL = 52; minW = 20; maxW = 28;
            } else if (
              productHandle === '2-inch-memory-foam-mattress-topper' ||
              productHandle === 'memory-foam-mattress-topper' ||
              productHandle === 'aeroflow-foam-mattress-topper'
            ) {
              minL = 60; maxL = 78; minW = 24; maxW = 72;
            } else if (productHandle === 'founders-mattress') {
              minL = 60; maxL = 84; minW = 24; maxW = 72;
            } else {
              minL = 60; maxL = 84; minW = 24; maxW = 78;
            }

            // Create .custom-size-wrapper with L and W inputs only (height comes from .height-value.active)
            const customSizeWrapper = document.createElement('div');
            customSizeWrapper.className = 'custom-size-wrapper hidden';
            customSizeWrapper.innerHTML = `
              <div class="custom-size-inputbox">
                <div class="csi-col-wrap flexbox">
                  <div class="csi-col length-option">
                    <label>Length (in)</label>
                    <input type="text" name="bundle-custom-length" min="${minL}" max="${maxL}" value="${minL}">
                  </div>
                  <div class="csi-col width-option">
                    <label>Width (in)</label>
                    <input type="text" name="bundle-custom-width" min="${minW}" max="${maxW}" value="${minW}">
                  </div>
                  <div class="csi-col height-option${productHandle === 'baby-mattress' ? ' hidden' : ''}">
                    <label>Height (in)</label>
                    <div class="bundle-selected-height">—</div>
                  </div>
                </div>
                <div class="bundle-error-msg"></div>
                <div class="note_content"><strong>Note: </strong>Custom size mattresses are non returnable</div>
              </div>
            `;
            productDiv.appendChild(customSizeWrapper);

            const bundleCustomLengthInput = customSizeWrapper.querySelector('[name="bundle-custom-length"]');
            const bundleCustomWidthInput = customSizeWrapper.querySelector('[name="bundle-custom-width"]');

            // Assign handleBundleCustomChange (also called on height change via the height click listener)
            handleBundleCustomChange = () => {
              const lengthVal = parseInt(bundleCustomLengthInput.value.trim(), 10);
              const widthVal = parseInt(bundleCustomWidthInput.value.trim(), 10);
              // Height comes from the currently active height-value for this product
              const heightVal = productDiv.querySelector('.height-value.active')?.getAttribute('data-value')
                || (product.handle === 'founders-mattress' ? '9' : null);
              const errorElem = customSizeWrapper.querySelector('.bundle-error-msg');

              // Update the height display
              const heightDisplay = customSizeWrapper.querySelector('.bundle-selected-height');
              if (heightDisplay) heightDisplay.textContent = heightVal ? `${heightVal} inch` : '—';

              const minLength = parseInt(bundleCustomLengthInput.min, 10);
              const maxLength = parseInt(bundleCustomLengthInput.max, 10);
              const minWidth = parseInt(bundleCustomWidthInput.min, 10);
              const maxWidth = parseInt(bundleCustomWidthInput.max, 10);

              if (isNaN(lengthVal) || lengthVal < minLength || lengthVal > maxLength) {
                errorElem.textContent = `Length must be between ${minLength} - ${maxLength} inch`;
                return;
              }
              if (isNaN(widthVal) || widthVal < minWidth || widthVal > maxWidth) {
                errorElem.textContent = `Width must be between ${minWidth} - ${maxWidth} inch`;
                return;
              }
              errorElem.textContent = '';

              const dIdx = product.options.findIndex(opt => opt.toLowerCase() === 'dimension');
              if (dIdx === -1) return;
              const dKey = `option${dIdx + 1}`;

              const allAvailableDimensions = variantInfo
                .filter(v => v[dKey])
                .map(v => {
                  const parts = v[dKey].split(/\s*x\s*/i).map(p => parseInt(p.trim(), 10));
                  return { length: parts[0], width: parts[1], height: parts[2] || null, raw: v[dKey], variant: v };
                })
                .filter(d => {
                  if (heightVal) return d.height === parseInt(heightVal, 10);
                  return true;
                });

              let possibleLengths = allAvailableDimensions.map(d => d.length).filter(l => l >= lengthVal).sort((a, b) => a - b);
              let possibleWidths = allAvailableDimensions.map(d => d.width).filter(w => w >= widthVal).sort((a, b) => a - b);

              let matchedDimObj = null;
              bundleCustomSizeLoop:
              for (let l of possibleLengths) {
                for (let w of possibleWidths) {
                  for (let dim of allAvailableDimensions) {
                    if (dim.length === l && dim.width === w) {
                      matchedDimObj = dim;
                      break bundleCustomSizeLoop;
                    }
                  }
                }
              }

              if (!matchedDimObj && allAvailableDimensions.length > 0) {
                matchedDimObj = allAvailableDimensions.reduce((closest, dim) => {
                  const diff = Math.abs(dim.length - lengthVal) + Math.abs(dim.width - widthVal);
                  const closestDiff = Math.abs(closest.length - lengthVal) + Math.abs(closest.width - widthVal);
                  return diff < closestDiff ? dim : closest;
                }, allAvailableDimensions[0]);
              }

              if (matchedDimObj && matchedDimObj.variant) {
                let matchedVariant = matchedDimObj.variant;
console.log("matchedVariant", matchedVariant)
                // If matched variant not available, find next available size up
                if (!matchedVariant.available) {
                  const greaterOrEqualDims = allAvailableDimensions
                    .filter(d => d.length >= lengthVal && d.width >= widthVal)
                    .sort((a, b) => {
                      const diffA = (a.length - lengthVal) + (a.width - widthVal);
                      const diffB = (b.length - lengthVal) + (b.width - widthVal);
                      return diffA - diffB;
                    });
                  const availableGreaterDims = greaterOrEqualDims.filter(d => d.variant && d.variant.available);
                  if (availableGreaterDims.length > 0) {
                    matchedVariant = availableGreaterDims[0].variant;
                  } else {
                    errorElem.textContent = 'Sorry, no available sizes are in stock for the entered dimensions.';
                    return;
                  }
                }

                const customSizeStr = heightVal
                  ? `${lengthVal} x ${widthVal} x ${heightVal}`
                  : `${lengthVal} x ${widthVal}`;

                const stickyBtn = document.querySelector('.product-sticky-bar-wrap.bundle-product .sticky-addtobundle-btn.bundle_btn');
                if (stickyBtn) {
                  stickyBtn.dataset.variantId = matchedVariant.id;
                  stickyBtn.setAttribute('data-variant-title', matchedVariant.title);
                  stickyBtn.setAttribute('data-sku', matchedVariant.sku);
                  stickyBtn.setAttribute('data-custom-size', customSizeStr + ' inches');
                  stickyBtn.disabled = false;
                }

                // Update #pincode with mapped SKU
                document.querySelector('#pincode')?.setAttribute('data-sku', matchedVariant.sku);

                const extraDiscount = parseFloat(document.querySelector('.customBundle_block').getAttribute('data-bundle-discount') || 0);
                const discountedPrice = matchedVariant.price - (matchedVariant.compare_at_price * (extraDiscount / 100));
                const discountAmt = matchedVariant.compare_at_price * (extraDiscount / 100);
                const formattedPriceStr = Shopify.formatMoney(matchedVariant.price, Shopify.money_format).replace(/\.00$/, '');
                const formattedCompareAtPriceStr = Shopify.formatMoney(matchedVariant.compare_at_price, Shopify.money_format).replace(/\.00$/, '');

                const variantInfoEl = document.querySelector('.customBundle_wrapper .variant-info');
                if (variantInfoEl) {
                  variantInfoEl.innerHTML = `
                    <div class="price_wrapper only">
                      <div class="sale_price flexbox" data-price="${matchedVariant.price}" data-discounted-price="${discountedPrice}" data-extra-discountamt="${discountAmt}">
                        Price: <span class="sale_price_wrap">${formattedPriceStr}</span>
                        <div class="comapre_price flexbox align-flex-end" data-compareprice="${matchedVariant.compare_at_price}">
                          <span class="comapre_price_wrap">${formattedCompareAtPriceStr}</span>
                        </div>
                      </div>
                    </div>
                  `;
                }
              }
            };

            // Custom size pill click: toggle wrapper visibility, hide/show dimension dropdown
            const customSizePillEl = productDiv.querySelector('.variant-pill-list-wrap .custom-size');
            if (customSizePillEl) {
              customSizePillEl.addEventListener('click', () => {
                // Always activate — only deactivated by clicking a regular variant pill
                if (customSizePillEl.classList.contains('active')) return;

                customSizePillEl.classList.add('active');
                customSizeWrapper.classList.remove('hidden');
                const dimensionDropdown = productDiv.querySelector('.product_customDropdown, .custom-dimension-option-group');
                if (dimensionDropdown) dimensionDropdown.classList.add('hidden');

                // Hide the height column for mattress-topper products;
                // the existing CSS rule hides width-option::after automatically
                // when its next sibling (.csi-col.height-option) has class .hidden
                const activeHandle = document.querySelector('.product-title-btn.active')?.getAttribute('data-handle') || '';
                if (activeHandle.includes('mattress-topper')) {
                  customSizeWrapper.querySelector('.custom-size-inputbox .csi-col.height-option')?.classList.add('hidden');
                }

                document.querySelector('#pincode')?.setAttribute('data-custom', 'true');
                productDiv.querySelectorAll('.variant-pill-list-wrap input[type="radio"]').forEach(r => r.checked = false);
                document.querySelector('#checkPincodeDesc')?.style.setProperty('display', 'none');
                showBundleMTOMessage('custom');
                handleBundleCustomChange();
              });
            }

            // Re-run on L/W input change
            [bundleCustomLengthInput, bundleCustomWidthInput].forEach(inp => {
              if (inp) {
                inp.addEventListener('input', handleBundleCustomChange);
                inp.addEventListener('change', handleBundleCustomChange);
              }
            });
          }
        }

        // Converter logic
        const converterButtons = customGroupDiv.querySelectorAll(".converter_wrapper .convert");
        // const dimensionLabel = customGroupDiv.querySelector(".dimension-label");
  
        if (converterButtons.length) {
          // console.log("found!!!!!!!!!!", converterButtons)
          converterButtons.forEach((btn) => {
            btn.addEventListener("click", function () {
              const dimensionLabel = customGroupDiv.querySelector(".dimension-label");
              if (!dimensionLabel) return;
              customGroupDiv.querySelector(".dimension-label");
 
              converterButtons.forEach((elemBtn) => elemBtn.classList.remove("active"));
              btn.classList.add("active");
      
              const sizeElems = customGroupDiv.querySelectorAll(".dimension-list li");
              // console.log("sizeElems-----", sizeElems.length)
              if (!sizeElems.length) return;
      
              
              const selectedSizeVal = dimensionLabel.getAttribute("data-selected") || "";
              let convertedVal = selectedSizeVal;
      
              sizeElems.forEach((sizeElem) => {
                const size_val = sizeElem.getAttribute("data-value");
                // console.log("size_val!!!!!!!!!!!!!!!!!!!!!!!!!!!!", size_val)
                if (!size_val) return;
              
                let newText = size_val;
                if (btn.classList.contains("convert_cm")) {
                  newText = size_val
                    .split("x")
                    .map(v => (parseFloat(v.trim()) * 2.54).toFixed(1))
                    .join(" x ");
                  newText += ' cm';
                  if (size_val === selectedSizeVal) {
                    convertedVal = newText;
                  }
                } else if (btn.classList.contains("convert_feet")) {
                  newText = size_val
                    .split("x")
                    .map(v => {
                      let feet = parseFloat(v.trim()) / 12;
                      return feet.toFixed(2).replace(/\.0+$/, '').replace(/(\.\d)0+$/, '$1');
                    })
                    .join(" x ");
                  newText += ' feet';
                  if (size_val === selectedSizeVal) {
                    convertedVal = newText;
                  }
                } else if (btn.classList.contains("convert_inch")) {
                  newText = size_val + ' inches';
                  if (size_val === selectedSizeVal) {
                    convertedVal = newText;
                  }
                }
                sizeElem.textContent = newText;
              });
              
              if (dimensionLabel) {
                // if(dimensionLabel.textContent != 'Select a size'){
                  dimensionLabel.textContent = convertedVal || "Select a size";
                // }
                
              }
            });
          });
        }
      }
      // If get and dimension option custom functionality
      productDiv.appendChild(groupDiv);
    });

      function updateProductMediaByAlt(productElem, product) {
       const selectedOptions = {};
        product.options.forEach((_, optIndex) => {
          const val = productElem.querySelector(`input[name="option${optIndex}-${pIndex}"]:checked`)?.value;
          selectedOptions[`option${optIndex + 1}`] = val || "";
        });
  
        const matched = product.variants.find(v =>
          (!selectedOptions.option1 || v.option1 === selectedOptions.option1) &&
          (!selectedOptions.option2 || v.option2 === selectedOptions.option2) &&
          (!selectedOptions.option3 || v.option3 === selectedOptions.option3)
        );

console.log("selectedOptions", selectedOptions, "matched", matched);
            if (!matched) return;
            let matchedSku = matched.sku;
            console.log("matchedSku----------------------------------", matchedSku)
            const selectedlabel = document.querySelector(".bundle-product.active .dimension-wrapper .custom-dropdown .dimension-label")
            console.log("selectedlabel--------------------", selectedlabel)
            selectedlabel?.setAttribute("data-sku", matchedSku);
            selectedlabel?.setAttribute("data-price", matched.price);
            selectedlabel?.setAttribute("data-compare_at_price", matched.compare_at_price);

            const pincodeWrapper = document.querySelector(".pincode-wrapper input#pincode");
            const comparePriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
            comparePriceWrapper?.setAttribute("data-compareprice", matched.compare_at_price);
            const priceWrapper = document.querySelector(".price_wrapper.only .sale_price");
            priceWrapper?.setAttribute("data-discounted-price", matched.price);

            const formattedPrice = Shopify.formatMoney(matched.price, Shopify.money_format).replace(/\.00$/, "");
            const salepriceWrapper = document.querySelector(".price_wrapper.only .sale_price_wrap");
            if (salepriceWrapper) salepriceWrapper.innerText = formattedPrice;

            const formattedCompareAtPrice = Shopify.formatMoney(matched.compare_at_price, Shopify.money_format).replace(/\.00$/, "");
            const comparepriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
            if (comparepriceWrapper) comparepriceWrapper.innerText = formattedCompareAtPrice;

            const showPincodeMsg = document.getElementById("checkPincodeDesc");
            if (showPincodeMsg) showPincodeMsg.style.display = 'none';

            pincodeWrapper?.setAttribute("data-sku", matchedSku);
const colorGrp = document.querySelector(".option-group.color");
if(colorGrp){
  console.log("color found!!!")
}
        if(matched){
          const altText = matched.media_alt ?? matched.featured_media?.alt;
          // console.log("Alt text",altText);
          if (!altText) return;
      
          const altValues = altText.split("\n").map(str => str.trim().toLowerCase());
          const elements = document.querySelectorAll("[data-media-alt]");
      
          elements.forEach(el => {
            // console.log("el",el);
            const dataValue = el.getAttribute("data-media-alt")?.trim().toLowerCase();
            // console.log("dataValue",dataValue);
            const isMatch = altValues.some(alt => dataValue.includes(alt));
            // console.log("isMatch",isMatch);
            if (!dataValue.includes("all")) {
              el.classList.toggle("swiper-slide", isMatch);
              el.classList.toggle("non-swiper-slide", !isMatch);
              el.classList.toggle("hidden", !isMatch);
            }
            // console.log("el",el);
          });
          // console.log("Mian-slider",window.mainSlider);
          // console.log("thumbnailSlider",window.thumbnailSlider);
          requestAnimationFrame(() => {
           sliders();
          });
        }
        document.querySelectorAll('#saleribbon').forEach(el => el.remove());

        // Get the first visible slide
        const firstVisibleSlide = document.querySelector('.swiper-slide:not(.hidden)');
        
        // Add saleribbon if there's a visible slide and discount
        const extraDiscount = document.querySelector(".customBundle_block")?.getAttribute("data-bundle-discount");
        if (firstVisibleSlide && extraDiscount) {
          const ribbonHTML = `
            <div id="saleribbon">
              <span id="sale-discount-content">
                Extra <span class="ribbon-discount-pc">${extraDiscount}%</span> Off
              </span>
            </div>`;
        
          firstVisibleSlide.insertAdjacentHTML('afterbegin', ribbonHTML);
        }
      }
      
    
    // updateProductMediaByAlt(productDiv, product);
    
    function attachListeners(productElem, product) {
      console.log("attachListeners being called", product);
      // console.trace("li click:", this.getAttribute("data-value"));

      // const globalBtn = bundleActionContainer.querySelector(".global-add-to-bundle-btn");
      const stickyBarBtn = document.querySelector(".product-sticky-bar-wrap.bundle-product .sticky-addtobundle-btn.bundle_btn");
       
          const targetElement = document.querySelector(".customBundle_wrapper");
          let variantInfo = targetElement.querySelector(".variant-info");
          if (!variantInfo) {
  variantInfo = document.createElement("div");
  variantInfo.className = "variant-info";
  targetElement.prepend(variantInfo);
}
      // const variantInfo = bundleActionContainer.querySelector(".variant-info");
      // Handle custom dimension list
      const dimensionList = productElem.querySelectorAll(".dimension-wrapper li");
      if (dimensionList.length) {
        dimensionList.forEach((dimension) => {
          dimension.addEventListener("click", function (e) {
            dimensionList.forEach((el) => el.removeAttribute("selected"));
            dimension.setAttribute("selected", "selected");
           console.log("li click:", this.getAttribute("data-value"), "isTrusted:", e.isTrusted, "dimension=====", dimension);
            const selectedValue = this.getAttribute("data-value");
            console.log("selectedValue=====", selectedValue);
            const dimensionRadio = productElem.querySelector(`.option-group.dimension input[value="${selectedValue}"]`);
            const selectedlabel = document.querySelector(".bundle-product.active .dimension-wrapper .custom-dropdown .dimension-label")
            console.log("!!!!!!!!!!selected label!!!!!!!!!!", selectedlabel)
            if (product.handle === 'mattress-cover') {
              // 3-option product: no dimension radio in DOM, so resolve variant directly
              // using option1 (category) + option2 (mattress-type) + selectedValue (dimension)
              const mcOptions = {};
              product.options.forEach((_, optIndex) => {
                const val = productElem.querySelector(`input[name="option${optIndex}-${pIndex}"]:checked`)?.value;
                mcOptions[`option${optIndex + 1}`] = val || "";
              });
              const dimOptIdx = product.options.findIndex(opt => ['dimension','Dimension','DIMENSION'].includes(opt));
              if (dimOptIdx !== -1) mcOptions[`option${dimOptIdx + 1}`] = selectedValue;
              const mcMatched = product.variants.find(v =>
                (!mcOptions.option1 || v.option1 === mcOptions.option1) &&
                (!mcOptions.option2 || v.option2 === mcOptions.option2) &&
                (!mcOptions.option3 || v.option3 === mcOptions.option3)
              );
              if (mcMatched && selectedlabel) {
                selectedlabel.setAttribute("data-sku", mcMatched.sku);
                selectedlabel.setAttribute("data-price", mcMatched.price);
                selectedlabel.setAttribute("data-compare_at_price", mcMatched.compare_at_price);
                document.querySelector(".pincode-wrapper input#pincode")?.setAttribute("data-sku", mcMatched.sku);
                const comparePriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
                comparePriceWrapper?.setAttribute("data-compareprice", mcMatched.compare_at_price);
                const priceWrapper = document.querySelector(".price_wrapper.only .sale_price");
                priceWrapper?.setAttribute("data-discounted-price", mcMatched.price);
                const salepriceWrapper = document.querySelector(".price_wrapper.only .sale_price_wrap");
                if (salepriceWrapper) salepriceWrapper.innerText = Shopify.formatMoney(mcMatched.price, Shopify.money_format).replace(/\.00$/, "");
                if (mcMatched.compare_at_price && Number(mcMatched.compare_at_price) > 0) {
                  const comparepriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
                  if (comparepriceWrapper) comparepriceWrapper.innerText = Shopify.formatMoney(mcMatched.compare_at_price, Shopify.money_format).replace(/\.00$/, "");
                }
                const showPincodeMsg = document.getElementById("checkPincodeDesc");
                if (showPincodeMsg) showPincodeMsg.style.display = 'none';
              }
            } else if(selectedlabel && selectedlabel.getAttribute("data-sku")){
             let newSku = dimension.getAttribute("data-sku");
            let newPrice = dimension.getAttribute("data-price");
            let newComparePrice = dimension.getAttribute("data-compare_at_price");
            selectedlabel.setAttribute("data-sku",newSku);
            selectedlabel.setAttribute("data-price",newPrice);
            selectedlabel.setAttribute("data-compare_at_price",newComparePrice);
            const pincodeWrapper = document.querySelector(".pincode-wrapper input#pincode");
            pincodeWrapper?.setAttribute("data-sku", newSku);

            // Only update price display if the li has valid price data set on it.
            // For products where skuByDimension can't resolve per-dimension prices
            // (e.g. 3-option products like Size/Type/Dimension), the li won't have
            // data-price — in that case updateVariant() handles the price display.
            if (newPrice !== null && newPrice !== "null") {
              const comparePriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
              comparePriceWrapper?.setAttribute("data-compareprice", newComparePrice);
              const priceWrapper = document.querySelector(".price_wrapper.only .sale_price");
              priceWrapper?.setAttribute("data-discounted-price", newPrice);

              const formattedPrice = Shopify.formatMoney(newPrice, Shopify.money_format).replace(/\.00$/, "");
              const salepriceWrapper = document.querySelector(".price_wrapper.only .sale_price_wrap");
              if (salepriceWrapper) salepriceWrapper.innerText = formattedPrice;

              if (newComparePrice && newComparePrice !== "null" && Number(newComparePrice) > 0) {
                const formattedCompareAtPrice = Shopify.formatMoney(newComparePrice, Shopify.money_format).replace(/\.00$/, "");
                const comparepriceWrapper = document.querySelector(".price_wrapper.only .comapre_price_wrap");
                if (comparepriceWrapper) comparepriceWrapper.innerText = formattedCompareAtPrice;
              }

              const showPincodeMsg = document.getElementById("checkPincodeDesc");
              if (showPincodeMsg) showPincodeMsg.style.display = 'none';
            }
            console.log("new SKU should beeeeeeeeee", newSku)
            }
          

            const label = productElem.querySelector(".dimension-label");
            label.textContent = selectedValue + " inches";
            label.setAttribute("data-selected", selectedValue);
            label.classList.remove("active");

            const pillowTitleBtn = titlesContainer.querySelector(`.product-title-btn[data-handle="${product.handle}"]`);
            if (pillowTitleBtn && (pillowTitleBtn.dataset.handle || '').includes('pillow-cases')) {
              const origTitle = pillowTitleBtn.dataset.originalTitle || pillowTitleBtn.textContent;
              pillowTitleBtn.textContent = selectedValue ? `${origTitle} (${selectedValue})` : origTitle;
            }

            productElem.querySelector(".dimension-wrapper")?.classList.remove("error-active");
            productElem.querySelector(".variation-error")?.classList.add("hidden");

            // Click the dimension radio so updateVariant() runs with the correct
            // selected options and evaluates MTO status (shows/hides mto-message--standard)
            dimensionRadio?.click();

              const delivery_input = document.querySelector('.delivery_input');
              const input_pin = delivery_input?.querySelector('input#pincode');
              //  input_pin?.setAttribute('data-sku',matched.sku);
          });
        });
      }
    //     const dimensionLabel = document.querySelector(".dimension-label"); 
// if (firstLi && dimensionLabel) {
//   const selectedValue = firstLi.getAttribute("data-value");
//   firstLi.setAttribute("selected", "selected");
//   dimensionLabel.textContent = selectedValue + " inches";
//   dimensionLabel.setAttribute("data-selected", selectedValue);
//   productDiv
//     .querySelector(`.option-group.dimension input[value="${selectedValue}"]`)
//     ?.click();
// }
      const updateOptionsVisibility = (selectedOptions) => {
        // console.log("--------selectedOptions-----", selectedOptions);
        const { option1 } = selectedOptions;
        const matchingVariants = product.variants.filter((v) => v.option1 === option1);
        const validOption2 = [...new Set(matchingVariants.map(v => v.option2).filter(Boolean))];
        const validOption3 = [...new Set(matchingVariants.map(v => v.option3).filter(Boolean))];
    
        // Hide/show option2 radios
        const option2Inputs = productElem.querySelectorAll(`input[name="option1-${pIndex}"]`);
        option2Inputs.forEach((input) => {
          const label = productElem.querySelector(`label[for="${input.id}"]`);
          const visible = validOption2.includes(input.value);
          input.classList.toggle("hidden", !visible);
          label?.classList.toggle("hidden", !visible);
        });
    
        // Hide/show option3 radios
        const option3Inputs = productElem.querySelectorAll(`input[name="option2-${pIndex}"]`);
        option3Inputs.forEach((input) => {
          const label = productElem.querySelector(`label[for="${input.id}"]`);
          const visible = validOption3.includes(input.value);
          input.classList.toggle("hidden", !visible);
          label?.classList.toggle("hidden", !visible);
        });
    
        // Handle Dimension dropdown
        const dimensionWrapper = productElem.querySelector(".dimension-wrapper");
        if (dimensionWrapper) {
          const dimensionIndex = product.options.findIndex(opt => 
            opt === "dimension" || opt === "Dimension" || opt === "DIMENSION"
          );
        
          if (dimensionIndex !== -1) {
            const dimensionKey = `option${dimensionIndex + 1}`;
            // ✅ NEW: Narrow variants further ONLY for dimension calculation
    // (uses selectedOptions generically, no need to know "CATEGORY" vs "MATTRESS TYPE")
    const matchingVariantsForDimension = product.variants.filter((v) => {
      // apply any selected options except the dimension option itself
      // (do NOT anchor on option1 when option1 IS the dimension — that would hide all other sizes)
      for (let i = 1; i <= product.options.length; i++) {
        const key = `option${i}`;
        if (key === dimensionKey) continue; // ignore dimension
        if (selectedOptions[key] && v[key] !== selectedOptions[key]) return false;
      }

      return true;
    });
            // const validDimensionValues = [
            //   ...new Set(matchingVariants.map(v => v[dimensionKey]).filter(Boolean))
            // ];

                const validDimensionValues = [
              ...new Set(matchingVariantsForDimension.map(v => v[dimensionKey]).filter(Boolean))
            ];

                // ✅ ADD YOUR SNIPPET RIGHT HERE (exact point)
    dimensionWrapper.querySelectorAll(".dimension-list li.hidden").forEach(li => {
      li.classList.remove("not-available");
    });
        
            let visibleCount = 0;
        
           dimensionWrapper.querySelectorAll("li").forEach((li) => {
              const value = li.getAttribute("data-value");
              const shouldShow = validDimensionValues.includes(value);
              li.classList.toggle("hidden", !shouldShow);
            
              if (shouldShow && !li.classList.contains("not-available")) {
                visibleCount++;
              }
            });
           
            const mattress = selectedBundleProducts.find(item => item.category === "mattress");
            const pillow = selectedBundleProducts.find(item => item.category === "pillow");
            
            const autoSelectCategories = ['pillow', 'bedsheet', 'comforter', 'protector'];

            let isMatched = false;
              
            if (autoSelectCategories.includes(categoryName.toLowerCase())) {
              isMatched = selectedBundleProducts.some(item => item.category.toLowerCase() === categoryName.toLowerCase());
            }

            if(!isMatched){
              // Helper: check if a valid dimension li is currently selected
              const currentDimLabel = productElem.querySelector(".dimension-label");
              const currentDimSelected = (currentDimLabel?.getAttribute("data-selected") || "").trim();
              const currentDimLiValid = currentDimSelected
                ? dimensionWrapper.querySelector(`li.dimension-value[data-value="${currentDimSelected}"]:not(.hidden):not(.not-available)`)
                : null;

              if (autoSelectCategories.includes(categoryName)) {
                // Only auto-select first if no valid selection exists yet
                if (!currentDimLiValid) {
                  const visibleDimensionValues = dimensionWrapper.querySelectorAll(".dimension-value:not(.hidden)");
                  if (visibleDimensionValues.length) visibleDimensionValues[0].click();
                }
              }

              // Determine if current product already exists in selectedBundleProducts
              const currentSelected = selectedBundleProducts.find(
                item => item.category.toLowerCase() === categoryName.toLowerCase()
              );

              // If current product is already selected, apply its saved dimension
              // BUT only if the user hasn't already made a valid selection themselves
              if (currentSelected && currentSelected.selectedOptions && !currentDimLiValid) {
                const dimensionIndex = product.options.findIndex(opt =>
                  opt.toLowerCase() === "dimension"
                );

                if (dimensionIndex !== -1) {
                  const dimensionKey = `option${dimensionIndex + 1}`;
                  const matchedDimension = currentSelected.selectedOptions[dimensionKey]; // ← VALUE like "78 x 36 x 6"
                  // console.log("matched dimension",matchedDimension);
                  const dimensionItems = dimensionWrapper.querySelectorAll(".dimension-value:not(.hidden)");

                  dimensionItems.forEach((li) => {
                    if (li.getAttribute("data-value") === matchedDimension) {
                      const dimensionVal = li.getAttribute("data-value");
                      if (dimensionVal.split('x').length - 1 === 2) {
                        const parts = dimensionVal.split('x').map(p => p.trim());
                        const heightVal = parts[2]; // third value is height (e.g., "6")

                        const heightOptions = document.querySelectorAll('.height-values-container .height-value');

                        heightOptions.forEach(option => {
                          // console.log("heightVal-------", heightVal, "option.getAttribute('data-value')", option.getAttribute('data-value'))
                          if (option.getAttribute('data-value') === heightVal) {
                            option.click();
                          }
                        });
                      }
                      li.click();
                    }
                  });
                }
              }
            }
  
            // Hide dropdown if only one visible, available dimension
            const customDropdown = dimensionWrapper.querySelector(".custom-dropdown");
            if (visibleCount === 1) {
              customDropdown?.classList.add("hidden");
            } else {
              customDropdown?.classList.remove("hidden");
            }
          }
        }
        // ensureDimensionSelected();
      };
//     function ensureDimensionSelected() {
//   const dimensionWrapper = productElem.querySelector(".dimension-wrapper");
//   if (!dimensionWrapper) return;

//   const label = dimensionWrapper.querySelector(".dimension-label");
  
//   if (!label) return;

//   // pick first visible + available dimension
//   const firstLi = dimensionWrapper.querySelector(
//     "li.dimension-value:not(.hidden):not(.not-available)"
//   );
//   // console.log("--------inside update dimension-------- firstLi", firstLi)
//   if (!firstLi) return;

//   // firstLi.click();

//   const isUnset =
//     label.textContent.trim() !== label.getAttribute("data-selected");
// console.log("matching label.textContent", label.textContent, "and", label.getAttribute("data-selected"))
//   if (isUnset) {
//     firstLi.click(); // reuses your existing click handler (best)
//   }
// }

function ensureDimensionSelected() {
  const dimensionWrapper = productElem.querySelector(".dimension-wrapper");
  if (!dimensionWrapper) return;

  const label = dimensionWrapper.querySelector(".dimension-label");
  if (!label) return;

  const selected = (label.getAttribute("data-selected") || "").trim();

  // If nothing selected yet → pick first visible+available
  if (!selected || label.textContent.trim() === "Select a size") {
    const firstLi = dimensionWrapper.querySelector(
      "li.dimension-value:not(.hidden):not(.not-available)"
    );
    if (firstLi) firstLi.click();
    return;
  }

  // If the currently-selected value became hidden/not-available, re-pick
  const currentLi = dimensionWrapper.querySelector(
    `li.dimension-value[data-value="${CSS.escape(selected)}"]`
  );

  const currentInvalid =
    !currentLi ||
    currentLi.classList.contains("hidden") ||
    currentLi.classList.contains("not-available");

  if (currentInvalid) {
    const firstLi = dimensionWrapper.querySelector(
      "li.dimension-value:not(.hidden):not(.not-available)"
    );
    if (firstLi) firstLi.click();
  }
}


      const updateVariant = () => {
        const selectedOptions = {};
        product.options.forEach((_, optIndex) => {
          const val = productElem.querySelector(`input[name="option${optIndex}-${pIndex}"]:checked`)?.value;
          selectedOptions[`option${optIndex + 1}`] = val || "";
        });
    
        updateOptionsVisibility(selectedOptions);
        ensureDimensionSelected();
        const matched = product.variants.find(v =>
          (!selectedOptions.option1 || v.option1 === selectedOptions.option1) &&
          (!selectedOptions.option2 || v.option2 === selectedOptions.option2) &&
          (!selectedOptions.option3 || v.option3 === selectedOptions.option3)
        );
    
        if (matched) {
          console.log("matched in updateVariant-------",matched);
          // globalBtn.disabled = false;
          stickyBarBtn.disabled = false;
          // globalBtn.dataset.variantId = matched.id;
          stickyBarBtn.dataset.variantId = matched.id;
          // globalBtn.innerText = "Add to Bundle";
          
          // globalBtn.setAttribute("data-variant-title",matched.title);
          stickyBarBtn.setAttribute("data-variant-title",matched.title);

          // globalBtn.setAttribute("data-sku",matched.sku);
          stickyBarBtn.setAttribute("data-sku",matched.sku);

          // MTO message: show standard if variant is MTO and custom size not active
          if (!productElem.querySelector('.variant-pill-list-wrap .custom-size.active')) {
            if (isBundleVariantMTO(matched.id)) {
              showBundleMTOMessage('standard');
            } else {
              hideBundleMTOMessages();
            }
          }

          // const discountAmt = matched.price * (extraDiscount / 100);
          const discountAmt = matched.compare_at_price * (extraDiscount / 100);
          // console.log("discountAmt",discountAmt);
          const discountedPrice = matched.price - (matched.compare_at_price * (extraDiscount / 100));
          const roundedDownPrice = Math.floor(discountedPrice / 100) * 100; // round to lower rupee

          const formattedDiscountedPrice = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
          // console.log("discountedPrice",Shopify.formatMoney(discountedPrice, Shopify.money_format).replace(/\.00$/, ""));
          const selectedlabel = document.querySelector(".bundle-product.active .dimension-wrapper .custom-dropdown .dimension-label")


          let formattedPrice = Shopify.formatMoney(matched.price, Shopify.money_format).replace(/\.00$/, "");
          let formattedCompareAtPrice = Shopify.formatMoney(matched.compare_at_price, Shopify.money_format).replace(/\.00$/, "");
          // console.log("firstttttttttttttt", formattedPrice, "formattedDiscountedPrice", formattedDiscountedPrice, "formattedCompareAtPrice", formattedCompareAtPrice)
          variantInfo.innerHTML = `
            <div class="price_wrapper only">
              <div class="sale_price flexbox" data-price="${formattedPrice}" data-discounted-price="${discountedPrice}" data-extra-discountamt="${discountAmt}">
                Price: <span class="sale_price_wrap t">${formattedPrice}</span>
                <div class="comapre_price flexbox align-flex-end" data-compareprice="${matched.compare_at_price}">
                  <span class="comapre_price_wrap">${formattedCompareAtPrice}</span>
                </div>
                <span class="prestige-count">${getDiscountText(matched.compare_at_price, matched.price,extraDiscount)}</span>
              </div>
              
            </div>
          `;

          targetElement.prepend(variantInfo);

          // Debug panel: show selected SKU's inventory at bottom of page
          let inventoryQty = 'N/A';
          for (const cat of Object.values(window.bundle_data || {})) {
            if (!Array.isArray(cat)) continue;
            for (const bp of cat) {
              const v = bp.variants?.find(v => String(v.id) === String(matched.id));
              if (v) { inventoryQty = v.inventory_quantity ?? 'N/A'; break; }
            }
            if (inventoryQty !== 'N/A') break;
          }

          // let debugPanel = document.getElementById('bundle-sku-inventory-debug');
          // if (!debugPanel) {
          //   debugPanel = document.createElement('div');
          //   debugPanel.id = 'bundle-sku-inventory-debug';
          //   debugPanel.style.cssText = 'position:fixed;bottom:0;left:0;right:0;z-index:9999;background:#1a1a1a;color:#fff;font:13px/1.4 monospace;padding:8px 16px;display:flex;gap:24px;align-items:center;';
          //   document.body.appendChild(debugPanel);
          // }
          // debugPanel.innerHTML = `
          //   <span>🔍 <strong>SKU:</strong> ${matched.sku || '—'}</span>
          //   <span>📦 <strong>Inventory:</strong> ${inventoryQty}</span>
          //   <span>🆔 <strong>Variant ID:</strong> ${matched.id}</span>
          //   <span>🏷️ <strong>MTO:</strong> ${isBundleVariantMTO(matched.id) ? 'Yes' : 'No'}</span>
          // `;


        if(categoryName == 'bed'){
              const bedDimLabel = productElem.querySelector(".dimension-label");
              const bedDimSelected = bedDimLabel?.getAttribute("data-selected");
              const bedDimCurrentLi = bedDimSelected
                ? productElem.querySelector(`ul.dimension-list li.dimension-value[data-value="${CSS.escape(bedDimSelected)}"]:not(.hidden):not(.not-available)`)
                : null;
              if (!bedDimCurrentLi) {
                var dimensionInput = document.querySelector(".bundle-product.active ul.dimension-list li.dimension-value[data-value]:not(.hidden):not(.not-available)");
                if(dimensionInput !== null){
                   dimensionInput.click();
                }
              }
        }

          //Ak custom code
          // if(categoryName == 'bed'){
            const delivery_input = document.querySelector('.delivery_input');
            let showPincodeMsg = document.getElementById("checkPincodeDesc");
            if(delivery_input){
              const input_pin = delivery_input.querySelector('input#pincode');
                const bundletabBed = document.querySelector('.bundle_tab.bundle_tab_button[data-category="bed"] h4');
                if (bundletabBed) {
                bundletabBed.innerHTML = "furniture";
                 }
              if(input_pin){
                 input_pin.setAttribute('data-sku',matched.sku);
                // input_pin.setAttribute('data-producttype',matched.pro_type);
                input_pin.setAttribute('data-outofstock',matched.available);
                 showPincodeMsg.style.display = 'none';
              }
            }
          // }
          //End Ak custom code
        }else{
          productElem.querySelector(".option-group.dimension input:not(.hidden):not(.not-available)")?.click();
          productElem.querySelector(".option-group.pack-size input:not(.hidden):not(.not-available)")?.click();
        }
      };
    
      // Initial run
      updateVariant();
    
      // Input listeners
      const inputs = productElem.querySelectorAll("input[type='radio']");
      inputs.forEach((input) => {
        input.addEventListener("change", () => {
          // If custom size pill is active, handle based on which option group changed
          const customSizePillEl = productElem.querySelector('.variant-pill-list-wrap .custom-size');
          if (customSizePillEl && customSizePillEl.classList.contains('active')) {
            const changedGroup = input.closest('.option-group');
            const changedGroupName = changedGroup?.getAttribute('data-option-name');

            if (changedGroupName === 'dimension') {
              // Height changed while custom-size is active: update the height display
              // inside .custom-size-wrapper but keep it visible
              if (typeof handleBundleCustomChange === 'function') handleBundleCustomChange();
              return;
            }

            // Any other variant pill → deactivate custom-size and restore dimension dropdown
            customSizePillEl.classList.remove('active');
            const customSizeWrapperEl = productElem.querySelector('.custom-size-wrapper');
            if (customSizeWrapperEl) customSizeWrapperEl.classList.add('hidden');
            const dimensionDropdown = productElem.querySelector('.custom-dimension-option-group');
            if (dimensionDropdown) dimensionDropdown.classList.remove('hidden');
            document.querySelector('#pincode')?.setAttribute('data-custom', 'false');
            const checkPincodeDesc = document.querySelector('#checkPincodeDesc');
            if (checkPincodeDesc && checkPincodeDesc.innerHTML.trim() !== '') {
              checkPincodeDesc.style.display = 'block';
            }
          }

          const group = input.closest(".option-group");
          const groupName = group?.getAttribute("data-option-name");
          if (groupName === "category" || groupName === "size") {
            const label = productElem.querySelector(".dimension-label");

            // const alreadySelected =  selectedBundleProducts.find(
            //   item => item.category.toLowerCase() === categoryName.toLowerCase()
            // );

            if (product.handle === 'mattress-cover') {
              applyMattressCoverHeightFilter();
              const checkedMT = productElem.querySelector('.option-group[data-option-name="mattress-type"] input[type="radio"]:checked');
              const mtLabel = (checkedMT?.value || '').toLowerCase().trim();
              const defaultHeight = mtLabel.includes('ultima') ? '8' : '6';
              const preferredHeight = productElem.querySelector(`.height-value[data-value="${defaultHeight}"]:not(.hidden)`);
              (preferredHeight || productElem.querySelector('.height-values-container .height-value:not(.hidden)'))?.click();
            } else {
              productElem.querySelector(".height-values-container .height-value")?.click();
            }
            // label.textContent = "Select a size"; 
            // console.log("label set 1...");
            setTimeout(() => ensureDimensionSelected(), 0);
            const heightValue = productElem.querySelector(".height-value.active")?.getAttribute("data-value");
             setTimeout(function(){
               if(heightValue){
                 const dimensionItems = productElem.querySelectorAll(".dimension-list li:not(.hidden)");
                //  console.log("dimensionItems",dimensionItems);
                  dimensionItems.forEach((li) => {
                    const value = li.getAttribute("data-value");
                    const xCount = (value.match(/x/g) || []).length;
         
                    if (xCount === 2) {
                      const parts = value.split('x');
                      const last = parts[parts.length - 1].trim();
                      if (last == heightValue) {
                        li.classList.remove("not-available");
                      } else {
                         // console.log("not-available added 3");
                        li.classList.add("not-available");
                      }
                    } else {
                       // console.log("not-available added 4");
                      li.classList.add("not-available");
                    }
                  });
               }
             },100);
                  
                       
            if(categoryName == 'bedsheet' || categoryName == 'comforter' || categoryName=='protector'){
              const dimensionWrapper = document.querySelector(".bundle-product.active .dimension-list");
              if(dimensionWrapper){
                // Only auto-click if no dimension is currently selected
                // (let ensureDimensionSelected handle re-validation after updateVariant runs)
                const dimLabel = document.querySelector(".bundle-product.active .dimension-wrapper .dimension-label");
                const dimAlreadySelected = (dimLabel?.getAttribute("data-selected") || "").trim();
                if (!dimAlreadySelected) {
                  const visibleDimensionValue = dimensionWrapper.querySelector(".dimension-value:not(.hidden)");
                  visibleDimensionValue?.click();
                }
              }
            }
          } else if (product.handle === 'mattress-cover' && groupName === 'mattress-type') {
            applyMattressCoverHeightFilter();
            // Select the default height for the chosen mattress type
            const checkedMT = productElem.querySelector('.option-group[data-option-name="mattress-type"] input[type="radio"]:checked');
            const mtLabel = (checkedMT?.value || '').toLowerCase().trim();
            let defaultHeight;
            if (mtLabel.includes('ultima')) {
              defaultHeight = '8'; // Ultima hides h6, so default to h8
            } else {
              defaultHeight = '6'; // Original and Hybrid Latex both default to h6
            }
            const preferredHeight = productElem.querySelector(`.height-value[data-value="${defaultHeight}"]:not(.hidden)`);
            if (preferredHeight) {
              preferredHeight.click();
            } else {
              // Fallback: click first non-hidden height
              productElem.querySelector('.height-values-container .height-value:not(.hidden)')?.click();
            }
          }
          updateVariant();
          updateProductMediaByAlt(productDiv,product);
        });
      });

      const heightOptions = productElem.querySelectorAll(".height-values-container .height-value");

      function applyMattressCoverHeightFilter() {
        const checkedInput = productElem.querySelector('.option-group[data-option-name="mattress-type"] input[type="radio"]:checked');
        const selectedLabel = (checkedInput?.value || '').toLowerCase().trim();
        const h6  = productElem.querySelector('.height-value[data-value="6"]');
        const h10 = productElem.querySelector('.height-value[data-value="10"]');
        h6?.classList.remove('hidden');
        h10?.classList.remove('hidden');
        if (selectedLabel.includes('ultima')) {
          h6?.classList.add('hidden');
        } else if (selectedLabel.includes('hybrid')) {
          h10?.classList.add('hidden');
        }
        // "original" → all heights visible (reset above handles it)
      }

      if (product.handle === 'mattress-cover') {
        applyMattressCoverHeightFilter();
      }

      if(heightOptions.length){
        heightOptions.forEach((heightOpt)=>{
          heightOpt.addEventListener('click',function(){
              var dimensionInput = document.querySelector(".bundle-product.active ul.dimension-list li.dimension-value[data-value]:not(.hidden):not(.not-available)");

              dimensionInput.click();
            const label = productElem.querySelector(".dimension-label");
            const bedSelected =  selectedBundleProducts.find(
              item => item.category.toLowerCase() === 'bed'
            );
            if(!bedSelected){
              //  label.textContent = "Select a size";
            }

            // For mattress-cover, option3 (Dimension) has no radio input in the DOM
            // (isDimensionOpt=true skips pill rendering), so no change event fires and
            // updateVariant/updateProductMediaByAlt never run via the dimension-click path.
            // Resolve the correct variant here using the dimension-label's data-selected.
            if (product.handle === 'mattress-cover') {
              setTimeout(() => {
                const dimSelected = productElem.querySelector('.dimension-label')?.getAttribute('data-selected');
                if (!dimSelected) return;
                const selectedOptions = {};
                product.options.forEach((_, optIndex) => {
                  const val = productElem.querySelector(`input[name="option${optIndex}-${pIndex}"]:checked`)?.value;
                  selectedOptions[`option${optIndex + 1}`] = val || "";
                });
                // Inject dimension value for option3 since no radio exists for it
                const dimOptIndex = product.options.findIndex(opt => ['dimension','Dimension','DIMENSION'].includes(opt));
                if (dimOptIndex !== -1) {
                  selectedOptions[`option${dimOptIndex + 1}`] = dimSelected;
                }
                const matched = product.variants.find(v =>
                  (!selectedOptions.option1 || v.option1 === selectedOptions.option1) &&
                  (!selectedOptions.option2 || v.option2 === selectedOptions.option2) &&
                  (!selectedOptions.option3 || v.option3 === selectedOptions.option3)
                );
                if (!matched) return;
                const dimensionLabel = document.querySelector('.bundle-product.active .dimension-wrapper .custom-dropdown .dimension-label');
                dimensionLabel?.setAttribute('data-sku', matched.sku);
                dimensionLabel?.setAttribute('data-price', matched.price);
                dimensionLabel?.setAttribute('data-compare_at_price', matched.compare_at_price);
                document.querySelector('.pincode-wrapper input#pincode')?.setAttribute('data-sku', matched.sku);
              }, 50);
            }
          });
        });
      }
    }
    attachListeners(productDiv,product);
      titleBtn.addEventListener("click", (event) => {
      const handle = event.currentTarget.dataset.handle;

      document.querySelectorAll(".product-title-btn").forEach((btn) => btn.classList.remove("active"));
      titleBtn.classList.add("active");
    
      variantContainer.querySelectorAll(".bundle-product").forEach((p) => {
        p.style.display = "none";
        p.classList.remove("active");
      });
    
      productDiv.style.display = "block";
      productDiv.classList.add("active");

      // Deactivate custom size pill from any product (cleans up previous selection)
      document.querySelectorAll('.bundle-product .custom-size.active').forEach(pill => {
        pill.classList.remove('active');
        const prevProductDiv = pill.closest('.bundle-product');
        prevProductDiv?.querySelector('.custom-size-wrapper')?.classList.add('hidden');
        prevProductDiv?.querySelector('.custom-dimension-option-group')?.classList.remove('hidden');
      });
      document.querySelector('#pincode')?.setAttribute('data-custom', 'false');
      hideBundleMTOMessages();

      // Always select "Single" (or first) in the category option group on product switch
      const categoryOptGroup = productDiv.querySelector('.option-group[data-option-name="category"]');
      if (categoryOptGroup) {
        const singleRadio = categoryOptGroup.querySelector('input[type="radio"][value="Single"]')
          || categoryOptGroup.querySelector('input[type="radio"][value="single"]')
          || categoryOptGroup.querySelector('input[type="radio"]');
        if (singleRadio && !singleRadio.checked) {
          singleRadio.checked = true;
          singleRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Select first visible radio per option group
      product.options.forEach((_, optIndex) => {
        const firstRadio = productDiv.querySelector(`input[name="option${optIndex}-${pIndex}"]:not(.hidden)`);
        if (firstRadio) firstRadio.checked = true;
      });

      const categoryHandle = document.querySelector(".bundle_tab.active")?.getAttribute("data-category");
      const activeProductHandle = document.querySelector(".product-title-btn.active")?.getAttribute("data-handle");
      const categoryProducts = bundle_data[categoryHandle];
      const activeProduct = categoryProducts.find(p => p.handle === activeProductHandle); // console.log("activeProduct",activeProduct);
      
      if(matchedCategoryData){
        const categoryOptions = matchedCategoryData.options;
        // console.log("categoryOptions",categoryOptions);
        const categoryValues = matchedCategoryData.selectedOptions;
        
        const dimensionIndex =  categoryOptions.findIndex(opt => opt.toLowerCase() === "dimension"); 
        const dimensionValue = categoryValues[`option${dimensionIndex + 1}`];
        const activeProductDimension = activeProduct.options.findIndex(opt => opt.toLowerCase() === "dimension");

        var shortDimension;
        if(categoryName != 'mattress'){
          shortDimension = dimensionValue.split(" x ").slice(0, 2).join(" x ");
        }else{
          shortDimension = dimensionValue;
        }
        // const matchingVariant = product.variants.find(variant =>
        //   variant[`option${activeProductDimension + 1}`] === shortDimension
        // );  
        const matchingVariant = product.variants.find(variant => {
          return categoryOptions.every((optionName, index) => {
            const selectedValue = categoryValues[`option${index + 1}`];
            const variantValue = variant[`option${index + 1}`];
            return selectedValue === variantValue;
          });
        });
        // console.log("matchingVariant................",matchingVariant);
          
         if(matchingVariant){
          const option1 = matchingVariant.option1;
          const option2 = matchingVariant.option2;
          const option3 = matchingVariant.option3;
        
          const setRadioChecked = (dataOptionIndex, optionValue) => {
            const group = document.querySelector(`.bundle-product.active .option-group[data-option="${dataOptionIndex}"]`);
            if (group) {
              const input = group.querySelector(`input[type="radio"][value="${optionValue}"]`);
              if (input) {
                input.checked = true;
              }
            }
          };
          var dimensionWrapper = document.querySelector(".bundle-product.active .option-group.custom-dimension-option-group");
          if (activeProductDimension === 2) {
            setRadioChecked(1, option1);
            setRadioChecked(2, option2);
           
            if(dimensionWrapper){
              var dimensionInput = dimensionWrapper.querySelector(".dimension-list .dimension-value[data-value='"+ option3 +"']");
              // console.log("dimensionInput",dimensionInput);
              dimensionInput.click();
            }
          } else if (activeProductDimension === 1) {
            setRadioChecked(1, option1);
            setRadioChecked(3, option3);
            if(dimensionWrapper){
              var dimensionInput = dimensionWrapper.querySelector(".dimension-list .dimension-value[data-value='"+ option2 +"']");
              // console.log("dimensionInput",dimensionInput);
              dimensionInput.click();
            }
          } 
        }else{
          // console.log("first option should selected...");
          const activeBundleProduct = document.querySelector(".bundle-product.active");
          if (activeBundleProduct) {
            // Ensure all visible option groups (excluding dimension) have their first radio input selected
            const optionGroups = activeBundleProduct.querySelectorAll(".option-group:not(.custom-dimension-option-group)");
            optionGroups.forEach(group => {
              const inputs = group.querySelectorAll('input[type="radio"]');
              if (inputs.length > 0) {
                inputs[0].checked = true;
                inputs[0].dispatchEvent(new Event('change', { bubbles: true })); // if needed to trigger logic
              }
            });
          
            // Handle custom dimension first value click
            const dimensionWrapper = activeBundleProduct.querySelector(".option-group.custom-dimension-option-group");
            if (dimensionWrapper) {
              const firstDimensionValue = dimensionWrapper.querySelector(".dimension-list .dimension-value");
              if (firstDimensionValue) {
                // Simulate click to ensure it triggers associated logic
                firstDimensionValue.click();
              }
            }
          } 
        }
      }else {
        const baseProduct = selectedBundleProducts.find(
          item => item.category === "bed"
        ) || selectedBundleProducts.find(
          item => item.category === "mattress"
        );
      
        if (baseProduct) {
          const baseOptions = baseProduct.options;
          const baseValues = baseProduct.selectedOptions;
          const dimension = baseValues.option2;
          
          // Always extract only the first two parts for comparison
          const shortDimension = dimension.split(" x ").slice(0, 2).join(" x ").trim().toLowerCase();
          
          const baseDimensionIndex = baseOptions.findIndex(opt => opt.toLowerCase() === "dimension");
          const activeProductDimension = activeProduct.options.findIndex(opt => opt.toLowerCase() === "dimension");
          
          // Find a matching variant by comparing only the first 2 parts of the dimension
          const matchingVariant = product.variants.find(variant => {
            const variantValue = variant[`option${activeProductDimension + 1}`];
            if (!variantValue) return false;
          
            const variantShortDimension = variantValue.split(" x ").slice(0, 2).join(" x ").trim().toLowerCase();
            return variantShortDimension === shortDimension;
          });      
          // console.log("matchingVariant", matchingVariant);
      
          if (matchingVariant) {
            const option1 = matchingVariant.option1;
            const option2 = matchingVariant.option2;
            const option3 = matchingVariant.option3;
      
            const setRadioChecked = (dataOptionIndex, optionValue) => {
              const group = document.querySelector(`.bundle-product.active .option-group[data-option="${dataOptionIndex}"]`);
              if (group) {
                const input = group.querySelector(`input[type="radio"][value="${optionValue}"]`);
                if (input) {
                  input.checked = true;
                }
              }
            };
      
            const dimensionWrapper = document.querySelector(".bundle-product.active .option-group.custom-dimension-option-group");
      
            if (activeProductDimension === 2) {
              setRadioChecked(1, option1);
              setRadioChecked(2, option2);
      
              if (dimensionWrapper) {
                const dimensionInput = dimensionWrapper.querySelector(`.dimension-list .dimension-value[data-value='${option3}']`);
                // console.log("dimensionInput", dimensionInput);
                if (dimensionInput) dimensionInput.click();
              }
            } else if (activeProductDimension === 1) {
              setRadioChecked(1, option1);
              setRadioChecked(3, option3);
      
              if (dimensionWrapper) {
                const dimensionInput = dimensionWrapper.querySelector(`.dimension-list .dimension-value[data-value='${option2}']`);
                // console.log("dimensionInput", dimensionInput);
                if (dimensionInput) dimensionInput.click();
              }
            }
      
          } else {
            // console.log("first option should be selected...");
            const activeBundleProduct = document.querySelector(".bundle-product.active");
            if (activeBundleProduct) {
              const optionGroups = activeBundleProduct.querySelectorAll(".option-group:not(.custom-dimension-option-group)");
              optionGroups.forEach(group => {
                const inputs = group.querySelectorAll('input[type="radio"]');
                if (inputs.length > 0) {
                  inputs[0].checked = true;
                  inputs[0].dispatchEvent(new Event('change', { bubbles: true }));
                }
              });
      
              const dimensionWrapper = activeBundleProduct.querySelector(".option-group.custom-dimension-option-group");
              if (dimensionWrapper) {
                const firstDimensionValue = dimensionWrapper.querySelector(".dimension-list .dimension-value");
                if (firstDimensionValue) {
                  firstDimensionValue.click();
                }
              }
            }
          }
        }
      }

      //else{
      //    const mattress = selectedBundleProducts.find(
      //     item => item.category === "mattress"
      //   );
      //   if(mattress){
      //     const mattressOptions = mattress.options;
      //     const mattressValues = mattress.selectedOptions;
      //     const dimension = mattressValues.option2;
      //     var shortDimension;
      //     if(categoryName != 'mattress'){
      //       shortDimension = dimension.split(" x ").slice(0, 2).join(" x ");
      //     }else{
      //       shortDimension = dimension;
      //     }
         
      //     // console.log("shortDimension",shortDimension);
      //     const mattressDimensionIndex = mattressOptions.findIndex(opt => opt.toLowerCase() === "dimension");  // console.log("mattressDimensionIndex",mattressDimensionIndex);
  
      //     const activeProductDimension = activeProduct.options.findIndex(opt => opt.toLowerCase() === "dimension");
      //     // console.log("activeProductDimension",activeProductDimension);
      //     const matchingVariant = product.variants.find(variant =>
      //       variant[`option${activeProductDimension + 1}`] === shortDimension
      //     );            
  
      //     console.log("matchingVariant",matchingVariant);
        
      //     if(matchingVariant){
      //       const option1 = matchingVariant.option1;
      //       const option2 = matchingVariant.option2;
      //       const option3 = matchingVariant.option3;
          
      //       const setRadioChecked = (dataOptionIndex, optionValue) => {
      //         const group = document.querySelector(`.bundle-product.active .option-group[data-option="${dataOptionIndex}"]`);
      //         if (group) {
      //           const input = group.querySelector(`input[type="radio"][value="${optionValue}"]`);
      //           if (input) {
      //             input.checked = true;
      //           }
      //         }
      //       };
      //       var dimensionWrapper = document.querySelector(".bundle-product.active .option-group.custom-dimension-option-group");
      //       if (activeProductDimension === 2) {
      //         setRadioChecked(1, option1);
      //         setRadioChecked(2, option2);
             
      //         if(dimensionWrapper){
      //           var dimensionInput = dimensionWrapper.querySelector(".dimension-list .dimension-value[data-value='"+ option3 +"']");
      //           console.log("dimensionInput",dimensionInput);
      //           dimensionInput.click();
      //         }
      //       } else if (activeProductDimension === 1) {
      //         setRadioChecked(1, option1);
      //         setRadioChecked(3, option3);
      //         if(dimensionWrapper){
      //           var dimensionInput = dimensionWrapper.querySelector(".dimension-list .dimension-value[data-value='"+ option2 +"']");
      //           console.log("dimensionInput",dimensionInput);
      //           dimensionInput.click();
      //         }
      //       } 
      //     }else{
      //       console.log("first option should selected...");
      //       const activeBundleProduct = document.querySelector(".bundle-product.active");
      //       if (activeBundleProduct) {
      //         // Ensure all visible option groups (excluding dimension) have their first radio input selected
      //         const optionGroups = activeBundleProduct.querySelectorAll(".option-group:not(.custom-dimension-option-group)");
      //         optionGroups.forEach(group => {
      //           const inputs = group.querySelectorAll('input[type="radio"]');
      //           if (inputs.length > 0) {
      //             inputs[0].checked = true;
      //             inputs[0].dispatchEvent(new Event('change', { bubbles: true })); // if needed to trigger logic
      //           }
      //         });
          
      //         // Handle custom dimension first value click
              // const dimensionWrapper = activeBundleProduct.querySelector(".option-group.custom-dimension-option-group");
              // if (dimensionWrapper) {
              //   const firstDimensionValue = dimensionWrapper.querySelector(".dimension-list .dimension-value");
              //   if (firstDimensionValue) {
              //     // Simulate click to ensure it triggers associated logic
              //     firstDimensionValue.click();
              //   }
              // }
      //       }
      //     }
      //   }
      // }

     
    
      // Update gallery and re-attach listeners
      if (handle) {
        fetch(`/products/${handle}.js`)
          .then((res) => res.json())
          .then((productData) => {
            updateProductGallery(productData);
            requestAnimationFrame(() => {
              attachListeners(productDiv, productData);
              updateProductMediaByAlt(productDiv, productData);
            });
          });
      } else {
        attachListeners(productDiv, product);
      }
    // });

    
       });
  }); 
  const matchedCategoryData = selectedBundleProducts.find(item => item.category === categoryName);
  if(matchedCategoryData){
    const matchedProduct = matchedCategoryData.productTitle;
    // console.log("matchedProduct",matchedProduct);

    const titleBtns = document.querySelectorAll(".product-title-btn");
    titleBtns.forEach(function(title_btn){
      const title = title_btn.textContent;
      if(title == matchedProduct){
        title_btn.click();
      }
    })
  }else{
    const activeTitle = document.querySelector(".product-title-btn.active");
    activeTitle.click();
  }
  
  document.querySelector(".sticky-addtobundle-btn.bundle_btn")?.classList.remove("hidden");
  document.querySelector(".sticky-next-btn.bundle_btn")?.classList.add("hidden");
  }

  function updateProductGallery(product) {
    const mainWrap = document.querySelector('.selected-media-wrap');
    const thumbWrap = document.querySelector('.product-gallery__thumbnail-list');
    if (!mainWrap || !thumbWrap) return;
    mainWrap.innerHTML = '';
    thumbWrap.innerHTML = '';
    product.media.forEach(media => {
      mainWrap.insertAdjacentHTML('beforeend', generateMainSlide(media));
      thumbWrap.insertAdjacentHTML('beforeend', generateThumbnail(media));
    });
    
    let youtubePlayers = {};

    function loadYouTubeAPI() {
      if (window.YT && YT.Player) {
        initializeYouTubePlayers();
      } else {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
        window.onYouTubeIframeAPIReady = initializeYouTubePlayers;
      }
    }
      
    function initializeYouTubePlayers() {
      document.querySelectorAll(".youtube-lazy").forEach(wrapper => {
        const playButton = wrapper.querySelector(".youtube-play-button");
        const videoId = wrapper.dataset.videoId;
        const wrapperId = wrapper.id;
  
        if (!playButton || !videoId || !wrapperId) return;
  
        playButton.addEventListener("click", function () {
          wrapper.innerHTML = `<div id="${wrapperId}-player"></div>`;
  
          youtubePlayers[wrapperId] = new YT.Player(`${wrapperId}-player`, {
            videoId: videoId,
            playerVars: {
              autoplay: 1,
              rel: 0,
              modestbranding: 1,
              controls: 1
            },
            events: {
              onStateChange: (event) => {
                const player = event.target;
  
                // Handle video END
                if (event.data === YT.PlayerState.ENDED) {
                  restorePoster(wrapper, videoId, wrapperId);
                }
  
                // Handle PAUSE (center click or play/pause)
                if (event.data === YT.PlayerState.PAUSED) {
                  setTimeout(() => {
                    const state = player.getPlayerState();
                    const currentTime = player.getCurrentTime();
                    const duration = player.getDuration();
  
                    const nearStart = currentTime < 1;
                    const nearEnd = currentTime > duration - 1;
  
                    // Restore if still paused after short time
                    if (state === YT.PlayerState.PAUSED && (nearStart || nearEnd || true)) {
                      restorePoster(wrapper, videoId, wrapperId);
                    }
                  }, 500);
                }
              }
            }
          });
        });
      });
    }
      
    function restorePoster(wrapper, videoId, wrapperId) {
      wrapper.innerHTML = `
        <div class="youtube-poster flexbox align-center justify-center" style="background-image: url('https://img.youtube.com/vi/${videoId}/hqdefault.jpg')">
          <button class="youtube-play-button yt-lazyload-playbtn" aria-label="Play Video">
            <svg class="icon icon--pdp_youtube_play_icon " width="68" height="48" viewBox="0 0 68 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66.52 7.74C65.74 4.81 64.03 2.33 61.1 1.55C55.79 0.13 34 0 34 0C34 0 12.21 0.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74C0.0600001 13.05 0 24 0 24C0 24 0.0600001 34.95 1.48 40.26C2.26 43.19 3.97 45.67 6.9 46.45C12.21 47.87 34 48 34 48C34 48 55.79 47.87 61.1 46.45C64.03 45.67 65.74 43.19 66.52 40.26C67.94 34.95 68 24 68 24C68 24 67.94 13.05 66.52 7.74Z" fill="currentColor"></path>
              <path d="M45 24L27 14V34" fill="white"></path>
            </svg>
          </button>
        </div>
      `;
      initializeYouTubePlayers(); // Rebind play button
    }
    loadYouTubeAPI();
  
    sliders();
  }

  function generateMainSlide(media) {
    // console.log("media position",media.position);
    let slide = `<div class="swiper-slide" data-media-alt="${media.alt || media.media_alt || ""}" data-media-id="${media.id}" data-media-type="${media.media_type}">`;
    const extraDiscount = document.querySelector(".customBundle_block").getAttribute("data-bundle-discount");
    if (media.position == 1 && extraDiscount) {
      slide += `
        <div id="saleribbon">
          <span id="sale-discount-content">
            Extra <span class="ribbon-discount-pc">${extraDiscount}%</span> Off
          </span>
        </div>`;
      }
    switch (media.media_type) {
      case 'image':
        slide += `
          <div class="product-gallery__size-limiter">
            <div class="media-box" style="--media-height:${100 / media.aspect_ratio}%">
              <img class="product-gallery__image" loading="lazy" src="${media.src}" alt="${media.alt}" />
            </div>
          </div>`;
        break;
      case 'video':
        slide += `
          <div class="product-gallery__video">
            <div class="video-wrapper media-box">
              <video controls src="${media.sources[0].url}"></video>
            </div>
          </div>`;
        break;
      case 'external_video':
        slide += `
         <div class="product-gallery__external-video">
          <div class="video-wrapper media-box third-party youtube-lazy"
               data-video-id="${media.external_id}"
               id="youtube-${media.id}">
            <div class="youtube-poster flexbox align-center justify-center"
                 style="background-image: url('https://img.youtube.com/vi/${media.external_id}/hqdefault.jpg')">
              <button class="youtube-play-button yt-lazyload-playbtn" aria-label="Play Video">
                <!-- Replace this with actual icon rendering or SVG -->
               <svg class="icon icon--pdp_youtube_play_icon " width="68" height="48" viewBox="0 0 68 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66.52 7.74C65.74 4.81 64.03 2.33 61.1 1.55C55.79 0.13 34 0 34 0C34 0 12.21 0.13 6.9 1.55C3.97 2.33 2.27 4.81 1.48 7.74C0.0600001 13.05 0 24 0 24C0 24 0.0600001 34.95 1.48 40.26C2.26 43.19 3.97 45.67 6.9 46.45C12.21 47.87 34 48 34 48C34 48 55.79 47.87 61.1 46.45C64.03 45.67 65.74 43.19 66.52 40.26C67.94 34.95 68 24 68 24C68 24 67.94 13.05 66.52 7.74Z" fill="currentColor"></path><path d="M45 24L27 14V34" fill="white"></path></svg>
              </button>
            </div>
          </div>
        </div>`;
        break;
      case 'model':
        slide += `<div class="product-gallery__model">[3D model not supported in JS]</div>`;
        break;
    }
    slide += '</div>';
    return slide;
  }

  function generateThumbnail(media) {
    return `
      <div class="swiper-slide" data-media-id="${media.id}" data-media-alt="${media.alt || media.media_alt || ""}">
        <div class="media-box" style="--media-height:100%">
          <img loading="lazy" src="${media.preview_image.src}" alt="${media.alt}" width="130" />
        </div>
      </div>`;
  }
  function renderbundleImages(){
   // === Replace product gallery with metafield images start ===
      const mainSliderWrapper = document.querySelector('.selected-media-wrap');
      const thumbnailWrapper = document.querySelector('.product-gallery__thumbnail-list');
    
      if (!window.bundle_images || !bundle_images.images || !mainSliderWrapper || !thumbnailWrapper) return;
    
      // Clear existing media
      mainSliderWrapper.innerHTML = '';
      thumbnailWrapper.innerHTML = '';
    
      // Populate with metafield images
      bundle_images.images.forEach((src) => {
        const mainSlide = document.createElement('div');
        mainSlide.className = 'swiper-slide';
        mainSlide.innerHTML = `
          <div class="product-gallery__size-limiter">
            <div class="media-box" style="--media-height:75.01875468867217%">
              <img class="product-gallery__image" src="${src}" loading="lazy" />
            </div>
          </div>
        `;
        mainSliderWrapper.appendChild(mainSlide);
    
        const thumbSlide = document.createElement('div');
        thumbSlide.className = 'swiper-slide';
        thumbSlide.innerHTML = `
          <div class="media-box" style="--media-height:100%">
            <img src="${src}" loading="lazy" style="width: 100%;" />
          </div>
        `;
        thumbnailWrapper.appendChild(thumbSlide);
      });
    
      // Update Swipers if initialized
      if (window.mainSlider?.update) {
        window.mainSlider.update();
        window.mainSlider.slideTo(0);
      }
      if (window.thumbnailSlider?.update) {
        window.thumbnailSlider.update();
        window.thumbnailSlider.slideTo(0);
      }
    // === Replace product gallery with metafield images end ===
  }
  function renderSelectedVariants(category) {
    const container = document.querySelector(".customBundle_block .bundle_info_wrapper");
    container.innerHTML = "";

    const selectedCategoryProducts = selectedBundleProducts.filter(item => item.category === category);

    selectedCategoryProducts.forEach(product => {
   // const matchedProduct = bundle_data[category].find(
   //    item => item.title === product.productTitle
   //  );
   // console.log("handle",matchedProduct.handle);
   //  if (matchedProduct.handle) {
   //    fetch(`/products/${matchedProduct.handle}.js`)
   //      .then((res) => res.json())
   //      .then((productData) => {
   //        updateProductGallery(productData);
   //      });
   //  }
      renderbundleImages();
   
      const { productTitle, variantId, selectedOptions,quantity, price, comparePrice,variantSku, productHandle, dimensionValue } = product;

      const selectedProductWrapper = document.createElement("div");
      selectedProductWrapper.className = "customBundleProduct";
      selectedProductWrapper.setAttribute("data-variantid", variantId);

      // Summary content
      const summaryContent = document.createElement("div");
      summaryContent.className = "summaryContent";

      const titleEl = document.createElement("span");
      titleEl.className = "bundleItem-title";
      const isPillowCase = category === 'pillow' && (productHandle || '').includes('pillow-cases');
      titleEl.textContent = `${productTitle}${isPillowCase && dimensionValue ? ` (${dimensionValue})` : ''} x ${quantity}`;
      summaryContent.appendChild(titleEl);
  
      const optionsArray = Object.values(selectedOptions || {});
      const optionsEl = document.createElement("span");
      optionsEl.className = "bundleItem-variants";
      optionsEl.textContent = optionsArray.join(" | ");
      summaryContent.appendChild(optionsEl);
      
      const extraDiscount = document.querySelector(".customBundle_block").getAttribute("data-bundle-discount");
      
      const priceWrapper = document.createElement("div");
      priceWrapper.className = "customBundleSummary-itemprice";
      const discountAmt = comparePrice * (extraDiscount / 100);
      const discountedPrice = price - (comparePrice * (extraDiscount / 100));
      const roundedDownPrice = Math.floor(discountedPrice / 100) * 100; // round to lower rupee
  
      const formattedDiscountedPrice = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
      
      const formattedComparePrice = Shopify.formatMoney(comparePrice, Shopify.money_format).replace(/\.00$/, '');
      const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, '');
  
      priceWrapper.innerHTML = `
        <div class="price_wrapper">
          <div class="sale_price flexbox" data-price="${price}" data-discounted-price="${discountedPrice}" data-extra-discountamt="${discountAmt}">
          <span class="sale_price_wrap">${formattedComparePrice}</span>
          <div class="comapre_price flexbox align-flex-end" data-compareprice="${comparePrice}"><span class="comapre_price_wrap">${formattedDiscountedPrice}</span></div>
          <span class="prestige-count">${getDiscountText(comparePrice, price,extraDiscount)}</span></div>
          
        </div>
        `;
      summaryContent.appendChild(priceWrapper);
  
      // Append summary content
      selectedProductWrapper.appendChild(summaryContent);
  
      // Summary actions
      const summaryActions = document.createElement("div");
      summaryActions.className = "summaryActions";
  
      const editButton = document.createElement("button");
      editButton.className = "customBundle-Edit";
      editButton.setAttribute("data-edit", variantId);
      editButton.textContent = "Edit";
      summaryActions.appendChild(editButton);
  
      const removeButton = document.createElement("button");
      removeButton.className = "customBundle-Remove";
      removeButton.setAttribute("data-remove", variantId);
      removeButton.textContent = "Remove";
      summaryActions.appendChild(removeButton);
  
      // Append actions
      selectedProductWrapper.appendChild(summaryActions);
  
      // Append full product block to container
      container.appendChild(selectedProductWrapper);
  
      editButton.addEventListener('click',function(e){
        e.preventDefault();
        renderBundle(category);
      });
      removeButton.addEventListener('click',function(e){
       
        const indexToRemove = selectedBundleProducts.findIndex(item => item.category === category);
        if (indexToRemove !== -1) {
          selectedBundleProducts.splice(indexToRemove, 1);
        }
        // console.log("Updated Bundle Products after removal:", selectedBundleProducts);
        const matchedTab = document.querySelector(`.bundle_tab[data-category="${category}"]`);
        if (matchedTab) {
          matchedTab.classList.remove("added");
        }
          
        renderBundle(category);
        updateActionButtons();
      });
    });

    document.querySelector(".sticky-addtobundle-btn.bundle_btn")?.classList.add("hidden");
    document.querySelector(".sticky-next-btn.bundle_btn")?.classList.remove("hidden");

    // console.log('category',category);
    //AK custom code
    if(category == 'bed'){
      
    }
      //Ak custom code
    if(category == 'bed'){
      const bundletab = document.querySelector('.bundle_tab.bundle_tab_button[data-category="'+category+'"]');
      if(bundletab){
        
        if(bundletab.classList.contains('pin_valid')){
          const delivery_input = document.querySelector('.bundle_info_wrapper .delivery_input');
          if(delivery_input){
            delivery_input.classList.add('hidden');
          }
          
          
          const get_pincode = bundletab.getAttribute('data-pincode');
          const pincodeEligibleHTML = `
            <div class="custombundle-check-pincode-setFor">
              <span>Pincode is eligible for delivery:</span>
              <span id="custombundle-setPinCode" class="px-1">${get_pincode}</span>
              <span id="custombundle-changePinCode" class="fa fa-edit d-inline-block"></span>
            </div>
            `;
    
            // Select the .product-titles-container element
            const productTitlesContainer = document.querySelector('.bundle_info_wrapper .customBundleProduct');
            
            if (productTitlesContainer) {
              productTitlesContainer.insertAdjacentHTML('afterend', pincodeEligibleHTML);
            }
        }
      }
    }
    //End Ak custom code
    //End Ak custom code
    
  }

var selectedBundleProducts = [];
var bundleTabSwiper;

  function scrollToViewSummaryTop(){
    const targetElement = document.querySelector(".customBundle_wrapper");
    const header = document.querySelector("sticky-header"); // or whatever your header selector is
    
    if (targetElement) {
      const headerHeight = (header?.offsetHeight || 0) + 10;
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
    
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth"
      });
    }
  }

document.addEventListener("DOMContentLoaded", function () {
  console.log('[bundle_data] Raw product data from Shopify:', window.bundle_data);

  if (window.bundle_data) {
    Object.keys(window.bundle_data).forEach(function (category) {
      var data = window.bundle_data[category];

      if (data.minQuantity === 1) {
        var tabElement = document.querySelector(
          `.bundle_tab_button[data-category="${category}"]`
        );

        if (tabElement) {
          tabElement.classList.add("required");
        }
      }
    });
  }
  bundleTabSwiper = new Swiper('.bundle-tabs-wrapper', {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
    slideToClickedSlide: true,
    navigation: {
      nextEl: '.bundle-tabs-right',
      prevEl: '.bundle-tabs-left',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });

  //Share product to some apps
  const shareButton = document.querySelector(".social-share-btn");
  const pdpTitle = document.querySelector(".customBundle_block")?.getAttribute("data-pdp-title");
  const productTitle = `Hey! You should checkout this awesome bundle by Sleepycat called "${pdpTitle}"`;
  const productUrl = window.location.href;

  if(shareButton){
    shareButton.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({
            title: productTitle,
            url: productUrl
          });
          // console.log('Product shared successfully');
        } catch (err) {
          console.error('Error sharing:', err);
        }
      } 
    });
  }
  

  // var summaryTopBtn = document.querySelector(".view-summary-top-button");

  // const summaryTab = document.querySelector(".summary_tab");
  const bundleTabs = document.querySelectorAll(".bundle-tabs-wrapper .bundle_tab");

  
  function insertBundleNote(afterElement) {
    // Remove existing note if present
    document.querySelector('.bundle-note')?.remove();
    afterElement.insertAdjacentElement("afterend", bundleNote);
  }
  
  function injectNavButtons(activeTab) {
    function getActiveTabIndex() {
      const activeTab = document.querySelector(".bundle_tab_button.active");
      const allTabs = Array.from(document.querySelectorAll(".bundle_tab_button"));
      return allTabs.indexOf(activeTab);
    }
    
    // const navWrapperClass = "bundle-nav-buttons";
  
    // // Remove old buttons
    // document.querySelector(`.${navWrapperClass}`)?.remove();
  
    // If summary tab is active, do not inject buttons
    // if (summaryTab.classList.contains("active")) return;
    if (!activeTab.classList.contains("bundle_tab")) return;
  
    const allTabs = Array.from(bundleTabs);
    const currentIndex = allTabs.findIndex(tab => tab.classList.contains("active"));
    const customBundleBlock = document.querySelector(".customBundle_block");
    if (!customBundleBlock) return;
  
    // const navWrapper = document.createElement("div");
    // navWrapper.className = navWrapperClass;
    // navWrapper.style.marginTop = "16px";
  
    const createBtn = (text, onClick) => {
      const btn = document.createElement("button");
      btn.textContent = text;
    
      btn.className = "bundle-nav-btn";
      if (text.includes('Next')) {
        btn.classList.add('btn-next');
      } else if (text.includes('Previous')) {
        btn.classList.add('btn-previous');
      }
      btn.style.marginRight = "10px";
      btn.addEventListener("click", () => {
        // Remove nav buttons if navigating to summary
        // if (summaryTab.classList.contains("active")) {
        //   document.querySelector(`.${navWrapperClass}`)?.remove();
        //   return;
        // }
        onClick();

        scrollToViewSummaryTop();
        const activeIndex = getActiveTabIndex();
        if (activeIndex !== -1) {
          bundleTabSwiper.slideTo(activeIndex);
        }
        
      });
      return btn;
    };
  
    // if (currentIndex > 0) {
    //   // navWrapper.appendChild(createBtn("<< Previous", () => {
    //   //   allTabs[currentIndex - 1].click();
    //   // }));
    // }
  
    // if (currentIndex < allTabs.length - 1) {
    //   navWrapper.appendChild(createBtn("Next >>", () => {
    //     allTabs[currentIndex + 1].click();
    //   }));
    // } else {
    //   navWrapper.appendChild(createBtn("View Bundle Summary >>", () => {
    //     // summaryTab.click();
    //   }));
      
    // }
  
    // customBundleBlock.insertAdjacentElement("afterend", navWrapper);
    // insertBundleNote(navWrapper);
  }
  const bundleNote = document.createElement("div");
  bundleNote.className = 'bundle-note';
  bundleNote.innerHTML = `<span>* Bundle items might be shipped separately</span>`;
  
  // Utility function to safely insert the note


  if (bundleTabs.length) {
    bundleTabs.forEach((bundleTab) => {
      bundleTab.addEventListener("click", function () {
        // summaryTab.classList.remove("active");
        bundleTabs.forEach((bt) => bt.classList.remove("active"));
        this.classList.add("active");

        // summaryTopBtn.classList.remove("hidden");
          
        const selectedCategory = this.dataset.category;
        const alreadySelected = selectedBundleProducts.some(item => item.category === selectedCategory);
  
        if (alreadySelected) {
          renderSelectedVariants(selectedCategory);
          setTimeout(() => injectNavButtons(bundleTab), 100);
        } else {
          renderBundle(selectedCategory);

          // setTimeout(() => {
          //   const firstBtn = document.querySelector(".product-title-btn");
          //   if (firstBtn) firstBtn.click();
          // }, 30);
  
          const waitForContent = setInterval(() => {
            const container = document.querySelector(".customBundle_block .bundle_info_wrapper");
            // const actionButton = container?.querySelector(".global-add-to-bundle-btn");
  
            if (container) {
              clearInterval(waitForContent);
              injectNavButtons(bundleTab);
            }
          }, 100);
        }
      
        // const navButtons = document.querySelector(".bundle-nav-buttons");
        // if (navButtons) insertBundleNote(navButtons);

        // const selectedCategory = this.dataset.category;
        updateActionButtons();
      });
    });
  
    // Summary tab click — remove nav buttons
    // summaryTab.addEventListener("click", () => {
    //   bundleTabs.forEach((bt) => bt.classList.remove("active"));
    //   summaryTab.classList.add("active");
    //   // document.querySelector(".bundle-nav-buttons")?.remove();

    //   summaryTopBtn.classList.add("hidden");

    //   const addBtn = document.querySelector(".sticky-addtobundle-btn");
    //   const nextBtn = document.querySelector(".sticky-next-btn");
    //   const summaryBtn = document.querySelector(".view-summary-button");
    //   const addToCartBtn = document.querySelector(".sticky-addtocart-button");
    //   const checkpinbtn = document.querySelector(".sticky-checkpin");
      
    //   // // Hide all buttons first
    //   addBtn?.classList.add("hidden");
    //   nextBtn?.classList.add("hidden");
    //   summaryBtn?.classList.add("hidden");
    //   addToCartBtn?.classList.remove('hidden');
    //   checkpinbtn?.classList.add('hidden');
    
    //   updateActionButtons();
  
    //   const bundleBlock = document.querySelector(".customBundle-block");
    //   if (bundleBlock) insertBundleNote(bundleBlock);
    // });
  
    // Trigger first tab
    bundleTabs[0].click();
  }


  function formatPriceWithoutDecimals(price) {
    if (!price) return "-";
    return Math.round(price / 100).toLocaleString("en-IN");
  }

  // === Render Summary Tab ===
  function renderSummary() {
    renderbundleImages();
    const container = document.querySelector(".customBundle_block .bundle_info_wrapper");
    container.innerHTML = "";
  
    // Tabs: activate only summary
    const bundleTabs = document.querySelectorAll(".bundle_tab");
    
    // summaryTab.classList.add("active");
    bundleTabs.forEach((bt) => bt.classList.remove("active"));
    // 1. ATC Section
    const customBundleATC = document.createElement("div");
    customBundleATC.className = "customBundle-ATC bundle-summary";

    const wrapperDiv = document.createElement("div");
    wrapperDiv.className = "bundle-actions-wrapper"; 
    
    const atcButton = document.createElement("button");
    const stickyAtcButtn = document.querySelector(".sticky-addtocart-button");
    atcButton.className = "addToCart_btn finlaadd_bundle button button--full-width";
    atcButton.textContent = "Add To Cart";
  
    if (selectedBundleProducts.length === 0) {
      atcButton.classList.add("disabled");
      stickyAtcButtn.classList.add("disabled");
      atcButton.disabled = true;
      stickyAtcButtn.disabled = true;
      document.querySelector(".product-main-sticky-bar label[for='price_title']")?.classList.add('hidden');
      document.querySelector(".product-main-sticky-bar .compare-price")?.classList.add("hidden");
      document.querySelector(".product-main-sticky-bar .main-price")?.classList.add("hidden");
    }
  
    wrapperDiv.appendChild(atcButton);
    customBundleATC.appendChild(wrapperDiv);

    const savedPriceElem = document.createElement("div");
    savedPriceElem.className = "bundle-saveprice-elem";

    // 2. Summary Section
    const customBundleSummary = document.createElement("div");
    customBundleSummary.className = "custombundleSummary";

    const requiredCategories = Object.keys(window.bundle_data).filter(
      (cat) => window.bundle_data[cat].minQuantity === 1
    );
    
    // Step 2: Find which required categories are missing in selectedBundleProducts
    const selectedCategories = selectedBundleProducts.map(p => p.category);
    const missingCategories = requiredCategories.filter(reqCat => !selectedCategories.includes(reqCat));
    
    if (missingCategories.length === requiredCategories.length) {
      // All required categories are missing
      const message = document.createElement("div");
      message.className = "empty-summary-message";
      message.textContent = `*Add at least 1 product each from ${missingCategories.join(', ')} categories.`;
      customBundleSummary.appendChild(message);
    
      atcButton.classList.add("disabled");
      atcButton.disabled = true;
      stickyAtcButtn.classList.add("disabled");
      stickyAtcButtn.disabled = true;
    
    } else {
      // Product list
      selectedBundleProducts.forEach(product => {
        const {
          category,
          productTitle,
          productHandle: itemHandle,
          dimensionValue: itemDimensionValue,
          variantId,
          variantSku,
          quantity,
          selectedOptions,
          price,
          comparePrice,
          discountedPrice,
          extraDiscountAmt
        } = product;

        const id = `${category}-${variantId}`;

        const productSelected = document.createElement("div");
        productSelected.className = "customBundleProduct";
        productSelected.id = id;
        productSelected.dataset.qty = "1";
        productSelected.dataset.category = category;
        productSelected.dataset.producttype = category;
        productSelected.dataset.product_id = variantId;
        productSelected.dataset.variationid = variantId;

        const summaryContent = document.createElement("div");
        summaryContent.className = "summaryContent";

        const titleEl = document.createElement("span");
        titleEl.className = "bundleItem-title";
        const isPillowCaseItem = category === 'pillow' && (itemHandle || '').includes('pillow-cases');
        titleEl.textContent = `${productTitle}${isPillowCaseItem && itemDimensionValue ? ` (${itemDimensionValue})` : ''} x ${quantity}`;
        summaryContent.appendChild(titleEl);
  
        const optionsEl = document.createElement("span");
        optionsEl.className = "bundleItem-variants";
        const optionsArray = Object.values(selectedOptions || {});
        optionsEl.textContent = optionsArray.join(" | ");
        summaryContent.appendChild(optionsEl);

        const extraDiscount = document.querySelector(".customBundle_block").getAttribute("data-bundle-discount");

        const priceWrapper = document.createElement("div");
        priceWrapper.className = "customBundleSummary-itemprice";

      
        const roundedDownPrice = Math.floor(discountedPrice / 100) * 100; // round to lower rupee

        const formattedDiscountedPrice = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
        
        const formattedComparePrice = Shopify.formatMoney(comparePrice, Shopify.money_format).replace(/\.00$/, '');
        const formattedPrice = Shopify.formatMoney(price, Shopify.money_format).replace(/\.00$/, '');

        priceWrapper.innerHTML = `
          <div class="price_wrapper">
            <div class="sale_price flexbox" data-price="${price}" data-discounted-price="${discountedPrice}">
              <span class="sale_price_wrap">${formattedComparePrice}</span>
              <div class="comapre_price flexbox align-flex-end" data-compareprice="${comparePrice}">
                <span class="comapre_price_wrap">${formattedDiscountedPrice}</span>
              </div>
              <span class="prestige-count">${getDiscountText(comparePrice, price,extraDiscount)}</span>
            </div>
            
          </div>
        `;
        summaryContent.appendChild(priceWrapper);
        productSelected.appendChild(summaryContent);
  
        const summaryActions = document.createElement("div");
        summaryActions.className = "summaryActions";
  
        const removeButton = document.createElement("button");
        removeButton.className = "customBundle-Remove";
        removeButton.dataset.remove = id;
        removeButton.dataset.sku = "";
        removeButton.dataset.productcategory = category;
        removeButton.innerHTML = 'Remove';
        summaryActions.appendChild(removeButton);
  
        productSelected.appendChild(summaryActions);
        customBundleSummary.appendChild(productSelected);
      });

      if (missingCategories.length > 0) {
        const message = document.createElement("div");
        message.className = "empty-summary-message";
        message.textContent = `*Add at least 1 product each from ${missingCategories.join(', ')} category${missingCategories.length > 1 ? 'ies' : ''}.`;
        customBundleSummary.appendChild(message);
    
        atcButton.classList.add("disabled");
        atcButton.disabled = true;
        stickyAtcButtn.classList.add("disabled");
        stickyAtcButtn.disabled = true;
      }
      // 3. Bundle Total
      if (selectedBundleProducts.length > 0) {
        let totalComparePrice = 0;
        let totalActualPrice = 0;
        let totalDiscountedPrice = 0;
        let totalDiscountAmt = 0;
  
        selectedBundleProducts.forEach(product => {
          totalComparePrice += (parseInt(product.comparePrice || 0) * parseInt(product.quantity || 1));
          totalActualPrice += (parseInt(product.price || 0) * parseInt(product.quantity || 1));
          totalDiscountedPrice += (parseInt(product.discountedPrice || 0) * parseInt(product.quantity || 1));
          totalDiscountAmt += (parseInt(product.extraDiscountAmt || 0) * parseInt(product.quantity || 1));
        });
          const roundedDiscountAmt = Math.floor(totalDiscountAmt / 100) * 100; // round to lower rupee
        
        const combinedPriceWrapper = document.createElement("div");
        combinedPriceWrapper.className = "custombundleCombinedPrice";
  
        const combinedPriceInner = document.createElement("div");
        combinedPriceInner.className = "customBundleVariation-itemprice flexbox justify-space-between";
  
        const labelSpan = document.createElement("span");
        labelSpan.className = "bundle-total-title";
        labelSpan.textContent = "Bundle Total";
  
        const priceDiv = document.createElement("div");
        priceDiv.className = "bundletotal-priceinfo";

        const roundedDownPrice = Math.floor(totalDiscountedPrice / 100) * 100; // round to lower rupee
        
        const totalFormattedComparePrice = Shopify.formatMoney(totalComparePrice, Shopify.money_format).replace(/\.00$/, '');
        const totalFormattedPrice = Shopify.formatMoney(totalActualPrice, Shopify.money_format).replace(/\.00$/, '');
        const totalFormattedDiscountedPrice = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
        const totalFormattedDiscountAmt = Shopify.formatMoney(roundedDiscountAmt,Shopify.money_format).replace(/\.00$/, "");
       
        if(totalDiscountAmt > 0){
           savedPriceElem.innerHTML = `<span class="saved-price">* You save additional ${totalFormattedDiscountAmt}  off by upgrading to this bundle.</span>`
        }
        priceDiv.innerHTML = `
          <div class="price_wrapper TotalBundle_price flexbox align-center">
            <div class="sale_price flexbox" data-price="${totalActualPrice}" data-discounted-price="${totalDiscountedPrice}">
              <span class="sale_price_wrap">${totalFormattedComparePrice} </span>
            </div>
            <div class="comapre_price flexbox align-flex-end" data-compareprice="${totalComparePrice}">
              <span class="comapre_price_wrap">${totalFormattedDiscountedPrice}</span>
            </div>
          </div>
        `;
        
        combinedPriceInner.appendChild(labelSpan);
        combinedPriceInner.appendChild(priceDiv);
        combinedPriceWrapper.appendChild(combinedPriceInner);
  
        wrapperDiv.insertBefore(combinedPriceWrapper, atcButton);

        customBundleATC.appendChild(wrapperDiv);
        customBundleATC.appendChild(savedPriceElem);
        document.querySelector(".product-main-sticky-bar .left-col")?.classList.remove("active");
      }else{
        document.querySelector(".product-main-sticky-bar .left-col")?.classList.add("active");
      }
        
      // 4. Add remove logic
      const removeButtons = customBundleSummary.querySelectorAll(".customBundle-Remove");
      removeButtons.forEach((removeButton) => {
        removeButton.addEventListener('click', function () {
          const currentBundle = removeButton.closest(".customBundleProduct");
          const category = currentBundle.getAttribute("data-category");
          const matchedTab = document.querySelector(`.bundle_tab[data-category="${category}"]`);
          if (matchedTab) {
            matchedTab.classList.remove("added");
          }
  
          const indexToRemove = selectedBundleProducts.findIndex(item => item.category === category);
          if (indexToRemove !== -1) {
            selectedBundleProducts.splice(indexToRemove, 1);
            renderSummary(); // re-render UI
          }
        });
      });
    }
  
    // 5. Append Summary and ATC
    container.appendChild(customBundleSummary);
    container.appendChild(customBundleATC);
  
    // 6. Add to Cart logic
    const addToCart = customBundleATC.querySelector(".addToCart_btn");
    if (addToCart && !addToCart.disabled) {
      addToCart.addEventListener('click', function () {
        // console.log("selectedBundleProducts",selectedBundleProducts);
        const variantIdQtyMap = selectedBundleProducts
          .map(product => `${product.variantId}*${product.quantity}`)
          .join(',');

        const variantIds = selectedBundleProducts
        .map(product => `${product.variantId}`)
        .join(',');

        const variantSkus = selectedBundleProducts
        .map(product => `${product.variantSku}`)
        .join(',');
        // console.log("variantSkus",variantSkus);
        
        const productTitles = selectedBundleProducts.map(product => product.productTitle);
        const mainPdpTitle = document.querySelector(".customBundle_block").getAttribute("data-pdp-title");

        const discountPer = document.querySelector(".customBundle_block")?.getAttribute("data-bundle-discount");
        const totalPrice = document.querySelector(".bundletotal-priceinfo .sale_price").getAttribute("data-price");
        const totalComparePrice = document.querySelector(".bundletotal-priceinfo .comapre_price").getAttribute("data-compareprice");
        const totalDiscountedPrice = document.querySelector(".bundletotal-priceinfo .sale_price").getAttribute("data-discounted-price");
        // console.log("totalDiscountedPrice", Math.round(totalDiscountedPrice /100));

        const floatDiscountper = parseFloat(discountPer);
        const floatTotalPrice = parseFloat(totalPrice);
        // console.log("floatDiscountper",floatDiscountper);
        // console.log("floatTotalPrice",floatTotalPrice);
        const discountAmount = (floatDiscountper / 100) * floatTotalPrice;
        // console.log("discountAmount",discountAmount);
        
        const parentBundleVariantId = document.querySelector(".customBundle_block").getAttribute("data-mainpdp-id");
       // console.log("parentBundleVariantId",parentBundleVariantId);

       const formattedBundleItems = selectedBundleProducts.map(product => {
        const options = Object.values(product.selectedOptions || {}).map(option => {
          if (option.includes('x')) {
            return `${option} inches`;
          }
          return option;
        }).join(' | ');
      
        return `${product.productTitle} x ${product.quantity}\n${options}`;
      });
        // console.log("variantIdQtyMap",variantIdQtyMap);
        // console.log("formattedBundleItems",formattedBundleItems);
      
        const bundle_path = bundle_images.images[0].split("/files/")[1];
        let newBaseUrl = "https://cdn.shopify.com/s/files/1/0744/2376/3202/files/";
        let newUrl = newBaseUrl + bundle_path;
  
        const uniqueId = `${mainPdpTitle}-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
        const properties = {
          _bundle_type: "bundle",
          _bundle_ids : variantIds,
          _bundle_skus : variantSkus,
          _variant_ids: variantIdQtyMap,
          _bundle_name: `${mainPdpTitle}`,
          _bundle_price: Math.round(totalDiscountedPrice / 100),
          _bundle_comapre_price : totalComparePrice,
          _bundle_items: formattedBundleItems,
          _bundle_off_price: discountAmount,
          _bundle_unique_id: uniqueId,
          _bundle_image : newUrl
        };
        // console.log("properties",properties);
        
        const addToCartItems = selectedBundleProducts.map((product, index) => {
          const item = {
            id: product.variantId,
            quantity: Number(product.quantity),
            properties: {
              _bundle_unique_id: uniqueId,
              _bundle_name: `${mainPdpTitle}`
            }
          };

          // Attach bundle properties only to the first product
          if (index === 0) {
            Object.assign(item.properties, properties);
          }

          // Attach custom_size property for custom-sized items (e.g. mattress)
          if (product.customSize) {
            item.properties.custom_size = product.customSize;
          }

          return item;
        });
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: addToCartItems })
        })
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          console.log('Items added successfully:', data);
        })
        .catch(error => {
          console.error('Error adding items to cart:', error);
        })
        .finally(() => {
          const cartDrawer = document.querySelector('cart-drawer');
          const cartbtn = document.querySelector('.header__icon.header-cart-icon');
          cartbtn.click();
          if (cartDrawer && typeof cartDrawer.refresh === 'function') {
            cartDrawer.refresh(true);
          }
          const bundleTabs = document.querySelectorAll(".bundle_tab");
          bundleTabs.forEach((bundleTab)=>{
            bundleTab.classList.remove("added");
          });
          // cartbtn.dispatchEvent(new Event("click", { bubbles: true }));
          
          // const summaryTab = document.querySelector(".customBundle_block .bundle_info_wrapper");
          // summaryTab.innerHTML = '';
          // summaryTab.innerHTML = `<button class="custom-bundle-addBttn button button--full-width"> CREATE ANOTHER BUNDLE </button>`;
          // setTimeout(() => {
          //  selectedBundleProducts = [];
          // }, 0);
          document.querySelector(".custom-bundle-addBttn").addEventListener('click',function(){
            bundleTabs[0].click();
          });
        });
      });
    }
  }

  // Attach summary tab click
  // if (summaryTab) {
  //   summaryTab.addEventListener('click', renderSummary);
  // }
  // End --  View added Bundle Items 

  
  // if(summaryTopBtn){
  //   summaryTopBtn.addEventListener('click',function(){
  //     summaryTab.click();
  //     const slides = document.querySelectorAll('.bundle-tabs-wrapper .swiper-slide');
  //     const index = Array.from(slides).indexOf(summaryTab);

  //     if (index !== -1) {
  //       bundleTabSwiper.slideTo(index);
  //     } 
  //   });
  // }
  
});


  // Final Bundle add to cart with sticky bar add to cart
  var addToCartBtn = document.querySelector(".sticky-addtocart-button");
  if(addToCartBtn){
    addToCartBtn.addEventListener('click',function(){
      document.querySelector(".addToCart_btn.finlaadd_bundle")?.click();
    });
  }

  function updateActionButtons() {
    function getActiveTabIndex() {
      const activeTab = document.querySelector(".bundle_tab_button.active");
      const allTabs = Array.from(document.querySelectorAll(".bundle_tab_button"));
      return allTabs.indexOf(activeTab);
    }
    
    const activeTab = document.querySelector(".bundle_tab.active");
    if (!activeTab) return;
  
    const selectedCategory = activeTab.dataset.category;
    const allTabs = Array.from(document.querySelectorAll(".bundle_tab"));
    const isLastTab = activeTab === allTabs[allTabs.length - 1];
    const isRequired = activeTab.classList.contains("required");
  
    const selectedInBundle = selectedBundleProducts.some(
      (item) => item.category === selectedCategory
    );
  
    const requiredCategories = Object.keys(window.bundle_data).filter(
      (cat) => window.bundle_data[cat].minQuantity === 1
    );
  
    const allRequiredSelected = requiredCategories.every((cat) =>
      selectedBundleProducts.some((item) => item.category === cat)
    );
    
    if(allRequiredSelected){
      var stickyAddToCart = document.querySelector(".sticky-addtocart-button");
      if(stickyAddToCart){
        stickyAddToCart.classList.remove('disabled');
        stickyAddToCart.disabled = false;
      }
    }  
    
    const addBtn = document.querySelector(".sticky-addtobundle-btn");
    const nextBtn = document.querySelector(".sticky-next-btn");
    const summaryBtn = document.querySelector(".view-summary-button");
    const addToCartBtn = document.querySelector(".sticky-addtocart-button");
    const checkpinbtn = document.querySelector(".sticky-checkpin");

    // Hide all buttons first
    addBtn?.classList.add("hidden");
    nextBtn?.classList.add("hidden");
    summaryBtn?.classList.add("hidden");
    addToCartBtn?.classList.add("hidden");
    checkpinbtn?.classList.add("hidden");

    addBtn.addEventListener("click", function () {
      const customDropdown = document.querySelector(".custom-dropdown");
      const dimensionLabel = document.querySelector(".dimension-label");
      const dimensionWrapper = document.querySelector(".dimension-wrapper");
      const isCustomSizeActive = document.querySelector(".variant-pill-list-wrap .custom-size.active");

      // Check if dropdown is visible and no size selected (only when custom size is not active)
      if (!isCustomSizeActive && customDropdown && !customDropdown.classList.contains("hidden") && dimensionLabel && dimensionLabel.textContent.trim() === "Select a size") {
        dimensionWrapper?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      // Push selected variant to selectedBundleProducts
      const stickyBtn = document.querySelector(".product-sticky-bar-wrap.bundle-product .sticky-addtobundle-btn.bundle_btn");
      const activeCategory = document.querySelector(".bundle-tabs-wrapper .bundle_tab.active")?.dataset.category;
      const variantId = stickyBtn?.dataset.variantId;

      if (!activeCategory || !variantId) return;

      const variantTitle = stickyBtn.getAttribute("data-variant-title") || "";
      const variantSku = stickyBtn.dataset.sku || "";
      const customSizeStr = stickyBtn.getAttribute("data-custom-size") || null;

      const visibleProduct = document.querySelector(".bundle-product[style*='display: block']");
      const productIndex = visibleProduct?.dataset.productIndex;
      const productTitle = visibleProduct?.getAttribute("data-title") || "";
      const productHandle = document.querySelector(".product-title-btn.active")?.dataset.handle || "";
      const dimensionValue = visibleProduct?.querySelector(".dimension-label")?.getAttribute("data-selected") || "";

      const selectedOptions = {};
      visibleProduct?.querySelectorAll(".option-group").forEach(group => {
        const optIdx = group.dataset.option;
        const selected = group.querySelector("input[type='radio']:checked");
        if (selected && optIdx) selectedOptions[`option${optIdx}`] = selected.value;
      });
      if (customSizeStr) selectedOptions.customSize = customSizeStr;

      const variantInfoDiv = document.querySelector(".variant-info");
      const priceElem = variantInfoDiv?.querySelector(".sale_price");
      const comparePriceElem = variantInfoDiv?.querySelector(".comapre_price");
      const price = priceElem?.getAttribute("data-price") || "0";
      const comparePrice = comparePriceElem?.getAttribute("data-compareprice") || "0";
      const discountedPrice = priceElem?.getAttribute("data-discounted-price") || price;
      const extraDiscountAmt = priceElem?.getAttribute("data-extra-discountamt") || "0";

      // Remove existing entry for this category
      const indexToRemove = selectedBundleProducts.findIndex(item => item.category === activeCategory);
      if (indexToRemove !== -1) selectedBundleProducts.splice(indexToRemove, 1);

      const bundleItem = {
        category: activeCategory,
        productIndex,
        productTitle,
        productHandle,
        dimensionValue,
        variantId,
        variantTitle,
        variantSku,
        quantity: 1,
        selectedOptions,
        price,
        comparePrice,
        discountedPrice,
        extraDiscountAmt
      };
      if (customSizeStr) bundleItem.customSize = customSizeStr;

      selectedBundleProducts.push(bundleItem);

      // Mark tab as added
      const matchedTab = document.querySelector(`.bundle_tab[data-category="${activeCategory}"]`);
      if (matchedTab) matchedTab.classList.add("added");

      // Clear custom-size attribute for next use
      stickyBtn.removeAttribute("data-custom-size");

      renderSelectedVariants(activeCategory);
      updateActionButtons();
    });
    
  //Ak custom code
  // console.log('categoryName',categoryName);
  let bed_show_pincode = false;
  const bundletab = document.querySelector('.bundle_tab.bundle_tab_button.active[data-category="bed"]');
  if(bundletab){
    if(!bundletab.classList.contains('added') && !bundletab.classList.contains('pin_valid')){
       bed_show_pincode = true;
    }
  }
  //End Ak custom code
  
    // Logic
    if (isLastTab) {
      if (isRequired && !selectedInBundle) {
        addBtn?.classList.remove("hidden");
      } else if (!isRequired && !selectedInBundle) {
        addBtn?.classList.remove("hidden");
      } else {
        summaryBtn?.classList.remove("hidden");
      }
    } else {
      if (isRequired) {
        if (!selectedInBundle) {
          addBtn?.classList.remove("hidden");
        } else if (allRequiredSelected) {
          summaryBtn?.classList.remove("hidden");
        } else {
          nextBtn?.classList.remove("hidden");
        }
      } else {
        if (!selectedInBundle) {
          addBtn?.classList.remove("hidden");
        } else {
          summaryBtn?.classList.remove("hidden");
        }
      }
    }

    if(bed_show_pincode){
      document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn').forEach(btn => btn.classList.add('hidden'));
      document.querySelectorAll('.product-main-sticky-bar .add_to_bundle .bundle_btn.sticky-checkpin').forEach(btn => btn.classList.remove('hidden'));
    }
    
    // Calculate total prices
    let totalPrice = 0;
    let totalComparePrice = 0;
  
    selectedBundleProducts.forEach((item) => {
      const qty = parseInt(item.quantity) || 1;
      const price = parseFloat(item.discountedPrice) || 0;
      const comparePrice = parseFloat(item.comparePrice) || 0;
  
      totalPrice += price * qty;
      totalComparePrice += comparePrice * qty;
    });
    // console.log("Total Price:", totalPrice);
    // console.log("Total Compare Price:", totalComparePrice);
    
    const stickyTotalElem = document.querySelector(".product-main-sticky-bar .main-price");
    const titleElem = document.querySelector(".product-main-sticky-bar label[for='price_title']");
    const stickyComapreTotalElem = document.querySelector(".product-main-sticky-bar .compare-price");
    if(totalPrice > 0){
      const roundedDownPrice = Math.floor(totalPrice / 100) * 100; // round to lower rupee

    // const formattedDiscountedPrice = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
      
      stickyTotalElem.textContent = Shopify.formatMoney(roundedDownPrice, Shopify.money_format).replace(/\.00$/, "");
      stickyTotalElem.classList.remove('hidden');
      titleElem.classList.remove('hidden');
    }else{
      stickyTotalElem.classList.add('hidden');
      titleElem.classList.add('hidden');
    }
    
    if(totalComparePrice > 0){
      stickyComapreTotalElem.textContent = Shopify.formatMoney(totalComparePrice, Shopify.money_format).replace(/\.00$/, '');
      stickyComapreTotalElem.classList.remove('hidden');
      titleElem.classList.remove('hidden');
    }else{
      stickyComapreTotalElem.classList.add('hidden');
      titleElem.classList.add('hidden');
    }
    
    // Calculate total prices
    summaryBtn.addEventListener("click", function () {
      
      document.querySelector(".summary_tab")?.click();
       const activeIndex = getActiveTabIndex();
      if (activeIndex !== -1) {
        bundleTabSwiper.slideTo(activeIndex);
      }
      scrollToViewSummaryTop();
    });

    nextBtn?.addEventListener("click", () => {
     const bundleNext = document.querySelector(".bundle-nav-btn.btn-next");
      if(bundleNext) bundleNext.click();
       const activeIndex = getActiveTabIndex();
        if (activeIndex !== -1) {
          bundleTabSwiper.slideTo(activeIndex);
        }
      scrollToViewSummaryTop();
    });
  }

document.addEventListener("click", function (e) {
  // const targetButton = e.target.closest(".global-add-to-bundle-btn, .sticky-addtobundle-btn.bundle_btn");

  // if (targetButton) {

  //   const productElem = document.querySelector(".bundle-product.active");

  //   let activeProductElem = null;
    
  //   if (productElem) {
  //     const dropdown = productElem.querySelector(".custom-dropdown");
  //     const label = productElem.querySelector(".dimension-label");
    
  //     if (dropdown && !dropdown.classList.contains("hidden") && dropdown.contains(label)) {
  //       activeProductElem = label;
  //     }
  //   }
  //   if(activeProductElem && activeProductElem.textContent == 'Select a size'){
  //     document.querySelector(".bundle-product.active .variation-error")?.classList.remove("hidden");
  //     document.querySelector(".bundle-product.active .dimension-wrapper")?.classList.add("error-active");
  //   }else{
  //     const btn = e.target;
  //     const variantId = btn.dataset.variantId;
  //     const variantTitle = btn.dataset.variantTitle;
  //     console.log("SKU",btn.dataset.sku);
  //     const variantSku = btn.dataset.sku;

  //     const activeCategory = document.querySelector(".bundle-tabs-wrapper .bundle_tab.active")?.dataset.category;
  
  //     if (!activeCategory || !variantId) return;
  
  //     const visibleProduct = document.querySelector(".bundle-product[style*='display: block']");
  //     const productIndex = visibleProduct?.dataset.productIndex;
  
  //     const selectedOptions = {};
  //     const options = [];
  //     visibleProduct?.querySelectorAll(".option-group").forEach(group => {
  //       const optName = group.dataset.optionName;
  //       const optIndex = group.dataset.option;
  //       const selected = group.querySelector("input[type='radio']:checked");
  //       if (selected) {
  //         options.push(optName);
  //         selectedOptions[`option${optIndex}`] = selected.value;
  //       }
  //     });
  
  //     const variantInfoDiv = document.querySelector(".variant-info");
   
  //     // console.log("variantInfoDiv",variantInfoDiv);
      
  //     const comparePriceElem = variantInfoDiv.querySelector(".comapre_price");
  //     const priceElem = variantInfoDiv.querySelector(".sale_price");
  //     const price = priceElem.getAttribute("data-price");
  //     const comparePrice = comparePriceElem.getAttribute("data-compareprice");
  //     const discountedPrice = priceElem.getAttribute("data-discounted-price");
  //     const extraDiscountAmt = priceElem.getAttribute("data-extra-discountamt");
      
  //     const productTitle = visibleProduct.getAttribute("data-title");
  //     const quantity = document.querySelector(".bundle-action-container .quantity__input").value;
  
  //     // === NEW: Remove existing entries with same category ===
  //     const indexToRemove = selectedBundleProducts.findIndex(item => item.category === activeCategory);
  //     if (indexToRemove !== -1) {
  //       selectedBundleProducts.splice(indexToRemove, 1);
  //     }
  
  //     // Add the selected variant to the array
  //     selectedBundleProducts.push({
  //       category: activeCategory,
  //       productIndex,
  //       productTitle,
  //       variantId,
  //       variantTitle,
  //       variantSku,
  //       quantity,
  //       options,
  //       selectedOptions,
  //       price,
  //       comparePrice,
  //       discountedPrice,
  //       extraDiscountAmt
  //     });
  //     const matchedTab = document.querySelector(`.bundle_tab[data-category="${activeCategory}"]`);
  //     if (matchedTab) {
  //       matchedTab.classList.add("added");
  //     }
  
  //     // console.log("Selected Bundle Products:", selectedBundleProducts);
    
  //     // const requiredCategories = Object.keys(window.bundle_data).filter(
  //     //   (cat) => window.bundle_data[cat].minQuantity === 1
  //     // );

  //     // const selectedCategories = selectedBundleProducts.map(p => p.category);
  //     // const allRequiredSelected = requiredCategories.every(required => selectedCategories.includes(required));
      
  //     // if (allRequiredSelected) {
  //     //   console.log("All fields are required..");
  //     // } else {
  //     //   console.log("some of fields are required..");
  //     // }
  
  //     const bundleContentWrapper = document.querySelector(".bundle-content-wrapper");
  //     bundleContentWrapper.style.display = "none";
  
  //     renderSelectedVariants(activeCategory);
  //   }
  //    scrollToViewSummaryTop();
  //   updateActionButtons();
    
  // }
});


  //Ak custom code
  const product_bed_btn_bundle = document.querySelector(".sticky-checkpin.bundle_btn");
  // var product_bed_btn = document.querySelector(".product__info-wrapper .buy-buttons-block button.product-form__submit");
  if (product_bed_btn_bundle) {
    product_bed_btn_bundle.addEventListener('click', function (event) {
      // if(this.closest('.buy-buttons-block').classList.contains('bed_pro_invalid')){
        event.preventDefault();
        event.stopPropagation();

        const pin_check = document.querySelector(".delivery_input_main span#delpicMsg .pincode_unavailable");
        // const pincodebed_first = document.querySelector(".delivery_input_main #checkforpincodefirst");

        if(pin_check){
          pin_check.classList.add('error');
        }else{
          const pincodewrapper = document.querySelector(".pincode-wrapper");
          if(pincodewrapper){
            pincodewrapper.classList.add('error');

            const delpicMsg = document.querySelector(".delivery_input_main span#delpicMsg");
            if(delpicMsg){
              delpicMsg.innerHTML = '';
            }

            // if(pincodebed_first){
            //   pincodebed_first.style.display = "block";
            // }
            
          }
        }
      const targetElement = document.querySelector(".customBundle_block");
      const header = document.querySelector("sticky-header"); // or whatever your header selector is
      
      if (targetElement) {
        const headerHeight = (header?.offsetHeight || 0) + 10;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
      
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
      // }
    });
    
  }

document.addEventListener("click", function (e) {
  document.querySelectorAll(".dimension-wrapper").forEach(wrapper => {
    const label = wrapper.querySelector(".dimension-label");
    const dropdown = wrapper.querySelector(".custom-dropdown");

    if (!label || !dropdown) return;

    if (dropdown.contains(e.target)) {
      label.classList.toggle("active");
    } else {
      label.classList.remove("active");
    }
  });
});

